import { Inject, Injectable, Injector } from '@angular/core';


import { FootprintApiManager_alerts_for_entity_import_insertService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_alerts_for_entity_import_mainService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_alerts_mainService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_alerts_send_testService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_asn_order_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_asn_order_linesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_asn_ordersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_order_by_idService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_purchase_order_linesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_purchase_ordersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_purchase_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_sales_order_linesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_sales_order_lines_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_sales_ordersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_cancel_sales_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_capture_footprint_event_failuresService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_accountsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_accounts_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_asn_ordersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_asn_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_carriers_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_contacts_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_instructionService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_lots_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_materials_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_missing_shipmentsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_order_addresses_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_purchase_order_lines_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_purchase_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_sales_order_lines_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_sales_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_serial_numbersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_vendor_lotsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_create_vendor_lots_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_delete_purchase_order_linesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_delete_sales_order_linesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_entity_import_parse_errorsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_file_transfer_moveService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_file_transfer_pullService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_file_transfer_pushService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_file_transfer_testService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_find_and_cancel_ordersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_check_order_statusService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_confirm_entity_importService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_adjustment_export_dataService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_adjustment_export_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_adjustment_export_to_xmlService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_adjustment_import_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_adjustment_sampleService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_adjustment_schemaService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_adjustment_to_entity_import_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_check_import_requestsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_get_completed_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_inventory_export_dataService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_inventory_export_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_inventory_export_to_xmlService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_inventory_schemaService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_invoice_export_dataService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_invoice_export_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_invoice_schemaService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_material_import_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_material_to_entity_import_xml_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_export_dataService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_export_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_export_to_xmlService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_import_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_schemaService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_summary_dataService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_to_crud_batch_request_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_order_to_entity_import_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_json_shipment_contentsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_generic_serial_numbersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_json_entity_import_entity_schemaService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_footprint_manage_wavelength_transmissionsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_accountsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_accounts_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_asn_ordersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_asn_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_carriers_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_configurationService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_configuration_examplesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_contacts_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_date_from_footprintService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_inventoryService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_inventory_adjustments_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_inventory_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_lots_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_materials_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_order_addresses_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_orders_order_addresses_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_outbound_orders_confirmationService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_purchase_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_reason_codesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_report_data_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_return_notificationsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_sales_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_serial_numbers_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_user_defined_field_namesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_user_defined_field_valuesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_get_vendor_lots_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_insert_logService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_integrity_check_interface_subsetsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_inventory_adjustment_queryService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_inventory_snapshot_queryService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_is_asn_order_cancelable_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_lifecycle_cleanService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_list_integrationsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_list_processesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_list_statusesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_list_transaction_typesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_logs_cleanService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_lot_createService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_main_auto_email_execute_rules_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_messages_cleanService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_migrate_storage_to_utilitiesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_move_serial_numbers_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_order_revisionsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_owner_createService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_print_cloud_reportService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_purchase_order_createService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_purchase_order_queryService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_purge_old_recordsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_reset_locked_messagesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_sales_order_createService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_sales_order_queryService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_sales_order_shipping_summary_queryService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_sftp_pullService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_sftp_pushService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_adjustmentsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_configurationsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_controlService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_lifecycleService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_logsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_messagesService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_string_encryptService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_storage_testService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_submit_entity_import_json_requestService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_submit_entity_import_xml_requestService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_translate_material_from_footprint_to_public_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_translate_material_from_public_to_footprint_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_translate_sales_order_from_public_to_footprint_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_translate_serial_number_from_footprint_to_public_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_translate_serial_number_from_public_to_footprint_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_unpick_licenseplate_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_accounts_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_asn_orderService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_asn_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_carriers_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_contacts_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_dock_appointments_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_last_wavelength_transmissionService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_lots_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_material_packagingService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_materials_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_order_addresses_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_pallet_transactions_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_purchase_order_lines_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_purchase_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_sales_order_lines_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_sales_orders_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_serial_number_statuses_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_serial_numbersService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_shipmentsService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_vendor_lotService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_update_vendor_lots_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_validate_create_sales_order_request_flowService } from './FootprintApiManager.flow.index';
import { FootprintApiManager_vendor_lot_createService } from './FootprintApiManager.flow.index';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_FlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootprintApiManager: FootprintApiManager_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _alerts_for_entity_import_insert: FootprintApiManager_alerts_for_entity_import_insertService;
  public async alerts_for_entity_import_insert($inParams: { request_id?: string, project?: string, warehouse?: string }): Promise< { messages?: any[] }> {
    if(!this._alerts_for_entity_import_insert) { 
      this._alerts_for_entity_import_insert = this.injector.get(FootprintApiManager_alerts_for_entity_import_insertService);
    }
    return this._alerts_for_entity_import_insert.run($inParams);
  }
   
   

   
 
  private _alerts_for_entity_import_main: FootprintApiManager_alerts_for_entity_import_mainService;
  public async alerts_for_entity_import_main($inParams: { days?: number }): Promise< { messages?: any[] }> {
    if(!this._alerts_for_entity_import_main) { 
      this._alerts_for_entity_import_main = this.injector.get(FootprintApiManager_alerts_for_entity_import_mainService);
    }
    return this._alerts_for_entity_import_main.run($inParams);
  }
   
   

   
 
  private _alerts_main: FootprintApiManager_alerts_mainService;
  public async alerts_main($inParams: { days?: number, retry?: boolean, output?: boolean }): Promise< { messages?: any[] }> {
    if(!this._alerts_main) { 
      this._alerts_main = this.injector.get(FootprintApiManager_alerts_mainService);
    }
    return this._alerts_main.run($inParams);
  }
   
   

   
 
  private _alerts_send_test: FootprintApiManager_alerts_send_testService;
  public async alerts_send_test($inParams: { to?: string }): Promise< { success?: boolean, messages?: any[] }> {
    if(!this._alerts_send_test) { 
      this._alerts_send_test = this.injector.get(FootprintApiManager_alerts_send_testService);
    }
    return this._alerts_send_test.run($inParams);
  }
   
   

   
 
  private _cancel_asn_order_flow: FootprintApiManager_cancel_asn_order_flowService;
  public async cancel_asn_order_flow($inParams: { order_id: number, status_id: number }): Promise< { reasons?: string[] }> {
    if(!this._cancel_asn_order_flow) { 
      this._cancel_asn_order_flow = this.injector.get(FootprintApiManager_cancel_asn_order_flowService);
    }
    return this._cancel_asn_order_flow.run($inParams);
  }
   
   

   
 
  private _cancel_asn_order_lines: FootprintApiManager_cancel_asn_order_linesService;
  public async cancel_asn_order_lines($inParams: { order_lines: $frontendTypes.FootprintApiManager.input_cancel_asn_order_line[] }): Promise<void> {
    if(!this._cancel_asn_order_lines) { 
      this._cancel_asn_order_lines = this.injector.get(FootprintApiManager_cancel_asn_order_linesService);
    }
    return this._cancel_asn_order_lines.run($inParams);
  }
   
   

   
 
  private _cancel_asn_orders: FootprintApiManager_cancel_asn_ordersService;
  public async cancel_asn_orders($inParams: { orders: $frontendTypes.FootprintApiManager.input_cancel_asn_order[] }): Promise<void> {
    if(!this._cancel_asn_orders) { 
      this._cancel_asn_orders = this.injector.get(FootprintApiManager_cancel_asn_ordersService);
    }
    return this._cancel_asn_orders.run($inParams);
  }
   
   

   
 
  private _cancel_order_by_id: FootprintApiManager_cancel_order_by_idService;
  public async cancel_order_by_id($inParams: { order_id: number, order_notes?: string, order_type_id: number, order_class_id: number, order_status_id: number, validate?: boolean }): Promise< { success?: boolean, messages?: any[], error?: string }> {
    if(!this._cancel_order_by_id) { 
      this._cancel_order_by_id = this.injector.get(FootprintApiManager_cancel_order_by_idService);
    }
    return this._cancel_order_by_id.run($inParams);
  }
   
   

   
 
  private _cancel_purchase_order_lines: FootprintApiManager_cancel_purchase_order_linesService;
  public async cancel_purchase_order_lines($inParams: { order_lines: $frontendTypes.FootprintApiManager.input_cancel_purchase_order_line[] }): Promise<void> {
    if(!this._cancel_purchase_order_lines) { 
      this._cancel_purchase_order_lines = this.injector.get(FootprintApiManager_cancel_purchase_order_linesService);
    }
    return this._cancel_purchase_order_lines.run($inParams);
  }
   
   

   
 
  private _cancel_purchase_orders: FootprintApiManager_cancel_purchase_ordersService;
  public async cancel_purchase_orders($inParams: { orders: $frontendTypes.FootprintApiManager.input_cancel_purchase_order[] }): Promise<void> {
    if(!this._cancel_purchase_orders) { 
      this._cancel_purchase_orders = this.injector.get(FootprintApiManager_cancel_purchase_ordersService);
    }
    return this._cancel_purchase_orders.run($inParams);
  }
   
   

   
 
  private _cancel_purchase_orders_flow: FootprintApiManager_cancel_purchase_orders_flowService;
  public async cancel_purchase_orders_flow($inParams: { order_ids: number[] }): Promise< { errors?: string[] }> {
    if(!this._cancel_purchase_orders_flow) { 
      this._cancel_purchase_orders_flow = this.injector.get(FootprintApiManager_cancel_purchase_orders_flowService);
    }
    return this._cancel_purchase_orders_flow.run($inParams);
  }
   
   

   
 
  private _cancel_sales_order_lines: FootprintApiManager_cancel_sales_order_linesService;
  public async cancel_sales_order_lines($inParams: { order_lines: $frontendTypes.FootprintApiManager.input_cancel_sales_order_line[] }): Promise<void> {
    if(!this._cancel_sales_order_lines) { 
      this._cancel_sales_order_lines = this.injector.get(FootprintApiManager_cancel_sales_order_linesService);
    }
    return this._cancel_sales_order_lines.run($inParams);
  }
   
   

   
 
  private _cancel_sales_order_lines_flow: FootprintApiManager_cancel_sales_order_lines_flowService;
  public async cancel_sales_order_lines_flow($inParams: { order_id: number, order_line_numbers: number[], reason_code_id: number, reason_notes?: string }): Promise< { errors?: string[] }> {
    if(!this._cancel_sales_order_lines_flow) { 
      this._cancel_sales_order_lines_flow = this.injector.get(FootprintApiManager_cancel_sales_order_lines_flowService);
    }
    return this._cancel_sales_order_lines_flow.run($inParams);
  }
   
   

   
 
  private _cancel_sales_orders: FootprintApiManager_cancel_sales_ordersService;
  public async cancel_sales_orders($inParams: { orders: $frontendTypes.FootprintApiManager.input_cancel_sales_order[] }): Promise<void> {
    if(!this._cancel_sales_orders) { 
      this._cancel_sales_orders = this.injector.get(FootprintApiManager_cancel_sales_ordersService);
    }
    return this._cancel_sales_orders.run($inParams);
  }
   
   

   
 
  private _cancel_sales_orders_flow: FootprintApiManager_cancel_sales_orders_flowService;
  public async cancel_sales_orders_flow($inParams: { order_ids: number[] }): Promise< { errors?: string[] }> {
    if(!this._cancel_sales_orders_flow) { 
      this._cancel_sales_orders_flow = this.injector.get(FootprintApiManager_cancel_sales_orders_flowService);
    }
    return this._cancel_sales_orders_flow.run($inParams);
  }
   
   

   
 
  private _capture_footprint_event_failures: FootprintApiManager_capture_footprint_event_failuresService;
  public async capture_footprint_event_failures($inParams: { status_ids?: number[], days?: number, type_ids?: number[] }): Promise< { result?: any[] }> {
    if(!this._capture_footprint_event_failures) { 
      this._capture_footprint_event_failures = this.injector.get(FootprintApiManager_capture_footprint_event_failuresService);
    }
    return this._capture_footprint_event_failures.run($inParams);
  }
   
   

   
 
  private _create_accounts: FootprintApiManager_create_accountsService;
  public async create_accounts($inParams: { accounts?: $frontendTypes.FootprintApiManager.input_create_account[] }): Promise< { accounts?: $frontendTypes.FootprintApiManager.public_account[], errors?: string[] }> {
    if(!this._create_accounts) { 
      this._create_accounts = this.injector.get(FootprintApiManager_create_accountsService);
    }
    return this._create_accounts.run($inParams);
  }
   
   

   
 
  private _create_accounts_flow: FootprintApiManager_create_accounts_flowService;
  public async create_accounts_flow($inParams: { accounts?: $frontendTypes.FootprintApiManager.input_create_account[] }): Promise< { accounts?: $frontendTypes.FootprintApiManager.public_account[], errors?: string[] }> {
    if(!this._create_accounts_flow) { 
      this._create_accounts_flow = this.injector.get(FootprintApiManager_create_accounts_flowService);
    }
    return this._create_accounts_flow.run($inParams);
  }
   
   

   
 
  private _create_asn_orders: FootprintApiManager_create_asn_ordersService;
  public async create_asn_orders($inParams: { orders: $frontendTypes.FootprintApiManager.input_create_asn_order[] }): Promise< { orders?: $frontendTypes.FootprintApiManager.public_order[] }> {
    if(!this._create_asn_orders) { 
      this._create_asn_orders = this.injector.get(FootprintApiManager_create_asn_ordersService);
    }
    return this._create_asn_orders.run($inParams);
  }
   
   

   
 
  private _create_asn_orders_flow: FootprintApiManager_create_asn_orders_flowService;
  public async create_asn_orders_flow($inParams: { orders: $frontendTypes.FootprintApiManager.input_create_asn_order[] }): Promise< { orders?: $frontendTypes.FootprintApiManager.public_order[], errors?: string[] }> {
    if(!this._create_asn_orders_flow) { 
      this._create_asn_orders_flow = this.injector.get(FootprintApiManager_create_asn_orders_flowService);
    }
    return this._create_asn_orders_flow.run($inParams);
  }
   
   

   
 
  private _create_carriers_flow: FootprintApiManager_create_carriers_flowService;
  public async create_carriers_flow($inParams: { carriers: $frontendTypes.FootprintApiManager.input_create_carrier[] }): Promise< { errors?: string[], carriers?: $frontendTypes.FootprintApiManager.public_carrier[] }> {
    if(!this._create_carriers_flow) { 
      this._create_carriers_flow = this.injector.get(FootprintApiManager_create_carriers_flowService);
    }
    return this._create_carriers_flow.run($inParams);
  }
   
   

   
 
  private _create_contacts_flow: FootprintApiManager_create_contacts_flowService;
  public async create_contacts_flow($inParams: { contacts: $frontendTypes.FootprintApiManager.input_create_contact[] }): Promise< { contacts?: $frontendTypes.FootprintApiManager.public_contact[], errors?: string[] }> {
    if(!this._create_contacts_flow) { 
      this._create_contacts_flow = this.injector.get(FootprintApiManager_create_contacts_flowService);
    }
    return this._create_contacts_flow.run($inParams);
  }
   
   

   
 
  private _create_instruction: FootprintApiManager_create_instructionService;
  public async create_instruction($inParams: { instruction: $frontendTypes.FootprintApiManager.input_create_instruction }): Promise< { instruction?: $frontendTypes.FootprintApiManager.public_instruction }> {
    if(!this._create_instruction) { 
      this._create_instruction = this.injector.get(FootprintApiManager_create_instructionService);
    }
    return this._create_instruction.run($inParams);
  }
   
   

   
 
  private _create_lots_flow: FootprintApiManager_create_lots_flowService;
  public async create_lots_flow($inParams: { lots: $frontendTypes.FootprintApiManager.input_create_lot[] }): Promise< { lots?: $frontendTypes.FootprintApiManager.public_lot[], errors?: string[] }> {
    if(!this._create_lots_flow) { 
      this._create_lots_flow = this.injector.get(FootprintApiManager_create_lots_flowService);
    }
    return this._create_lots_flow.run($inParams);
  }
   
   

   
 
  private _create_materials_flow: FootprintApiManager_create_materials_flowService;
  public async create_materials_flow($inParams: { materials: $frontendTypes.FootprintApiManager.input_create_material[] }): Promise< { materials?: $frontendTypes.FootprintApiManager.public_material[], errors?: string[] }> {
    if(!this._create_materials_flow) { 
      this._create_materials_flow = this.injector.get(FootprintApiManager_create_materials_flowService);
    }
    return this._create_materials_flow.run($inParams);
  }
   
   

   
 
  private _create_missing_shipments: FootprintApiManager_create_missing_shipmentsService;
  public async create_missing_shipments($inParams: { rounds?: number, debug?: boolean }): Promise< { messages?: any[] }> {
    if(!this._create_missing_shipments) { 
      this._create_missing_shipments = this.injector.get(FootprintApiManager_create_missing_shipmentsService);
    }
    return this._create_missing_shipments.run($inParams);
  }
   
   

   
 
  private _create_order_addresses_flow: FootprintApiManager_create_order_addresses_flowService;
  public async create_order_addresses_flow($inParams: { order_addresses: $frontendTypes.FootprintApiManager.input_create_order_address[] }): Promise< { order_addresses?: $frontendTypes.FootprintApiManager.public_order_address[], errors?: string[] }> {
    if(!this._create_order_addresses_flow) { 
      this._create_order_addresses_flow = this.injector.get(FootprintApiManager_create_order_addresses_flowService);
    }
    return this._create_order_addresses_flow.run($inParams);
  }
   
   

   
 
  private _create_purchase_order_lines_flow: FootprintApiManager_create_purchase_order_lines_flowService;
  public async create_purchase_order_lines_flow($inParams: { order_lines: $frontendTypes.FootprintApiManager.input_create_purchase_order_line[] }): Promise< { order_lines?: $frontendTypes.FootprintApiManager.public_order_line[], errors?: string[] }> {
    if(!this._create_purchase_order_lines_flow) { 
      this._create_purchase_order_lines_flow = this.injector.get(FootprintApiManager_create_purchase_order_lines_flowService);
    }
    return this._create_purchase_order_lines_flow.run($inParams);
  }
   
   

   
 
  private _create_purchase_orders_flow: FootprintApiManager_create_purchase_orders_flowService;
  public async create_purchase_orders_flow($inParams: { orders: $frontendTypes.FootprintApiManager.input_create_purchase_order[] }): Promise< { orders?: $frontendTypes.FootprintApiManager.public_order[], errors?: string[] }> {
    if(!this._create_purchase_orders_flow) { 
      this._create_purchase_orders_flow = this.injector.get(FootprintApiManager_create_purchase_orders_flowService);
    }
    return this._create_purchase_orders_flow.run($inParams);
  }
   
   

   
 
  private _create_sales_order_lines_flow: FootprintApiManager_create_sales_order_lines_flowService;
  public async create_sales_order_lines_flow($inParams: { order_lines: $frontendTypes.FootprintApiManager.input_create_sales_order_line[] }): Promise< { order_lines?: $frontendTypes.FootprintApiManager.public_order_line[], errors?: string[] }> {
    if(!this._create_sales_order_lines_flow) { 
      this._create_sales_order_lines_flow = this.injector.get(FootprintApiManager_create_sales_order_lines_flowService);
    }
    return this._create_sales_order_lines_flow.run($inParams);
  }
   
   

   
 
  private _create_sales_orders_flow: FootprintApiManager_create_sales_orders_flowService;
  public async create_sales_orders_flow($inParams: { orders: $frontendTypes.FootprintApiManager.input_create_sales_order[] }): Promise< { orders?: $frontendTypes.FootprintApiManager.public_order[], errors?: string[] }> {
    if(!this._create_sales_orders_flow) { 
      this._create_sales_orders_flow = this.injector.get(FootprintApiManager_create_sales_orders_flowService);
    }
    return this._create_sales_orders_flow.run($inParams);
  }
   
   

   
 
  private _create_serial_numbers: FootprintApiManager_create_serial_numbersService;
  public async create_serial_numbers($inParams: { serial_numbers: $frontendTypes.FootprintApiManager.input_create_serial_number[] }): Promise< { serial_numbers: $frontendTypes.FootprintApiManager.public_serial_number[], errors: string[] }> {
    if(!this._create_serial_numbers) { 
      this._create_serial_numbers = this.injector.get(FootprintApiManager_create_serial_numbersService);
    }
    return this._create_serial_numbers.run($inParams);
  }
   
   

   
 
  private _create_vendor_lots: FootprintApiManager_create_vendor_lotsService;
  public async create_vendor_lots($inParams: { vendor_lots: $frontendTypes.FootprintApiManager.input_create_vendor_lot[] }): Promise< { vendor_lots?: $frontendTypes.FootprintApiManager.public_vendor_lot[] }> {
    if(!this._create_vendor_lots) { 
      this._create_vendor_lots = this.injector.get(FootprintApiManager_create_vendor_lotsService);
    }
    return this._create_vendor_lots.run($inParams);
  }
   
   

   
 
  private _create_vendor_lots_flow: FootprintApiManager_create_vendor_lots_flowService;
  public async create_vendor_lots_flow($inParams: { vendor_lots: $frontendTypes.FootprintApiManager.input_create_vendor_lot[] }): Promise< { vendor_lots?: $frontendTypes.FootprintApiManager.public_vendor_lot[], errors?: string[] }> {
    if(!this._create_vendor_lots_flow) { 
      this._create_vendor_lots_flow = this.injector.get(FootprintApiManager_create_vendor_lots_flowService);
    }
    return this._create_vendor_lots_flow.run($inParams);
  }
   
   

   
 
  private _delete_purchase_order_lines: FootprintApiManager_delete_purchase_order_linesService;
  public async delete_purchase_order_lines($inParams: { order_id: number, order_line_numbers: number[] }): Promise< { errors?: string[] }> {
    if(!this._delete_purchase_order_lines) { 
      this._delete_purchase_order_lines = this.injector.get(FootprintApiManager_delete_purchase_order_linesService);
    }
    return this._delete_purchase_order_lines.run($inParams);
  }
   
   

   
 
  private _delete_sales_order_lines: FootprintApiManager_delete_sales_order_linesService;
  public async delete_sales_order_lines($inParams: { order_id: number, order_line_numbers: number[] }): Promise< { errors?: string[] }> {
    if(!this._delete_sales_order_lines) { 
      this._delete_sales_order_lines = this.injector.get(FootprintApiManager_delete_sales_order_linesService);
    }
    return this._delete_sales_order_lines.run($inParams);
  }
   
   

   
 
  private _entity_import_parse_errors: FootprintApiManager_entity_import_parse_errorsService;
  public async entity_import_parse_errors($inParams: { request_id?: string }): Promise< { project?: string, warehouse?: string, reference?: string, summary?: string, request?: string, messages?: any[] }> {
    if(!this._entity_import_parse_errors) { 
      this._entity_import_parse_errors = this.injector.get(FootprintApiManager_entity_import_parse_errorsService);
    }
    return this._entity_import_parse_errors.run($inParams);
  }
   
   

   
 
  private _file_transfer_move: FootprintApiManager_file_transfer_moveService;
  public async file_transfer_move($inParams: { service_endpoint: string, container_name: string, authentication: { st: string, se: string, sv: string, sig: string }, file_extenstion?: string, source_folder: string, target_folder: string }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._file_transfer_move) { 
      this._file_transfer_move = this.injector.get(FootprintApiManager_file_transfer_moveService);
    }
    return this._file_transfer_move.run($inParams);
  }
   
   

   
 
  private _file_transfer_pull: FootprintApiManager_file_transfer_pullService;
  public async file_transfer_pull($inParams: { service_endpoint: string, container_name: string, folder: string, authentication: { st: string, se: string, sv: string, sig: string }, file_extenstion?: string, download?: boolean }): Promise< { files?: { transaction_id?: string, name?: string, content?: string }[], messages?: any[], success?: boolean }> {
    if(!this._file_transfer_pull) { 
      this._file_transfer_pull = this.injector.get(FootprintApiManager_file_transfer_pullService);
    }
    return this._file_transfer_pull.run($inParams);
  }
   
   

   
 
  private _file_transfer_push: FootprintApiManager_file_transfer_pushService;
  public async file_transfer_push($inParams: { service_endpoint: string, container_name: string, folder: string, authentication: { st: string, se: string, sv: string, sig: string }, files?: { name?: string, content?: any }[] }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._file_transfer_push) { 
      this._file_transfer_push = this.injector.get(FootprintApiManager_file_transfer_pushService);
    }
    return this._file_transfer_push.run($inParams);
  }
   
   

   
 
  private _file_transfer_test: FootprintApiManager_file_transfer_testService;
  public async file_transfer_test($inParams: {  }): Promise< { files?: { transaction_id?: string, name?: string, content?: string }[], messages?: any[], success?: boolean }> {
    if(!this._file_transfer_test) { 
      this._file_transfer_test = this.injector.get(FootprintApiManager_file_transfer_testService);
    }
    return this._file_transfer_test.run($inParams);
  }
   
   

   
 
  private _find_and_cancel_orders: FootprintApiManager_find_and_cancel_ordersService;
  public async find_and_cancel_orders($inParams: { project_lookup_code?: string, order_class?: string, order_type_id?: number, order_lookup_code?: string, owner_reference?: string, vendor_reference?: string, order_id?: number, order_notes?: string, order_age_days?: number, max_date?: string, order_id_exclude?: number, only_created?: boolean }): Promise< { success?: boolean, messages?: any[], order_ids?: number[], shipment_ids?: number[], error?: string }> {
    if(!this._find_and_cancel_orders) { 
      this._find_and_cancel_orders = this.injector.get(FootprintApiManager_find_and_cancel_ordersService);
    }
    return this._find_and_cancel_orders.run($inParams);
  }
   
   

   
 
  private _footprint_check_order_status: FootprintApiManager_footprint_check_order_statusService;
  public async footprint_check_order_status($inParams: { transaction_id?: string, integration_name?: string, update?: boolean }): Promise< { success?: boolean, messages?: string[], count?: number, status?: string }> {
    if(!this._footprint_check_order_status) { 
      this._footprint_check_order_status = this.injector.get(FootprintApiManager_footprint_check_order_statusService);
    }
    return this._footprint_check_order_status.run($inParams);
  }
   
   

   
 
  private _footprint_confirm_entity_import: FootprintApiManager_footprint_confirm_entity_importService;
  public async footprint_confirm_entity_import($inParams: { integration_name?: string }): Promise< { success?: boolean, messages?: string[], count?: number, status?: string }> {
    if(!this._footprint_confirm_entity_import) { 
      this._footprint_confirm_entity_import = this.injector.get(FootprintApiManager_footprint_confirm_entity_importService);
    }
    return this._footprint_confirm_entity_import.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_export_data: FootprintApiManager_footprint_generic_json_adjustment_export_dataService;
  public async footprint_generic_json_adjustment_export_data($inParams: { project?: string, material?: string, renderLots?: boolean, renderLicensePlates?: boolean, renderSerialNumbers?: boolean, hasTransmissions?: boolean, warehouse?: string, modifiedFrom?: string, modifiedTo?: string, take?: number, taskIds?: number[], typeIds?: number[], debug?: boolean, dateFormat?: string, operationCode?: string }): Promise< { DatexAdjustmentInfo?: $frontendTypes.FootprintApiManager.DatexAdjustmentInfo, taskIds?: number[], messages?: any[] }> {
    if(!this._footprint_generic_json_adjustment_export_data) { 
      this._footprint_generic_json_adjustment_export_data = this.injector.get(FootprintApiManager_footprint_generic_json_adjustment_export_dataService);
    }
    return this._footprint_generic_json_adjustment_export_data.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_export_flow: FootprintApiManager_footprint_generic_json_adjustment_export_flowService;
  public async footprint_generic_json_adjustment_export_flow($inParams: { project_lookup_code?: string, material_lookup_code?: string, render_lots?: boolean, render_license_plates?: boolean, render_serial_numbers?: boolean, integration_name?: string, transaction_id?: string, warehouse_name?: string, modified_from?: string, modified_to?: string, take?: number, has_transmissions?: boolean, output_messages?: boolean, operation_code?: string }): Promise< { DatexAdjustmentInfo?: $frontendTypes.FootprintApiManager.DatexAdjustmentInfo, messages?: any[] }> {
    if(!this._footprint_generic_json_adjustment_export_flow) { 
      this._footprint_generic_json_adjustment_export_flow = this.injector.get(FootprintApiManager_footprint_generic_json_adjustment_export_flowService);
    }
    return this._footprint_generic_json_adjustment_export_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_export_to_xml: FootprintApiManager_footprint_generic_json_adjustment_export_to_xmlService;
  public async footprint_generic_json_adjustment_export_to_xml($inParams: { DatexAdjustmentInfo?: $frontendTypes.FootprintApiManager.DatexAdjustmentInfo }): Promise< { DatexAdjustmentInfoXml?: string }> {
    if(!this._footprint_generic_json_adjustment_export_to_xml) { 
      this._footprint_generic_json_adjustment_export_to_xml = this.injector.get(FootprintApiManager_footprint_generic_json_adjustment_export_to_xmlService);
    }
    return this._footprint_generic_json_adjustment_export_to_xml.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_import_flow: FootprintApiManager_footprint_generic_json_adjustment_import_flowService;
  public async footprint_generic_json_adjustment_import_flow($inParams: { adjustments?: $frontendTypes.FootprintApiManager.DatexAdjustmentInfo[], transaction_id?: string, ingress_id?: string, source_platform?: string, submitAsync?: boolean, integration_name?: string, environment?: string, sender?: string, receiver?: string }): Promise< { messages?: any[], results?: { requestId?: string, project?: string, warehouse?: string, message?: string, entities?: any, transactionId?: string }[], reasons?: string[] }> {
    if(!this._footprint_generic_json_adjustment_import_flow) { 
      this._footprint_generic_json_adjustment_import_flow = this.injector.get(FootprintApiManager_footprint_generic_json_adjustment_import_flowService);
    }
    return this._footprint_generic_json_adjustment_import_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_sample: FootprintApiManager_footprint_generic_json_adjustment_sampleService;
  public async footprint_generic_json_adjustment_sample($inParams: {  }): Promise< { payload?: $frontendTypes.FootprintApiManager.DatexAdjustmentInfo, messages?: string[] }> {
    if(!this._footprint_generic_json_adjustment_sample) { 
      this._footprint_generic_json_adjustment_sample = this.injector.get(FootprintApiManager_footprint_generic_json_adjustment_sampleService);
    }
    return this._footprint_generic_json_adjustment_sample.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_schema: FootprintApiManager_footprint_generic_json_adjustment_schemaService;
  public async footprint_generic_json_adjustment_schema($inParams: { example?: boolean }): Promise< { DatexAdjustmentInfo?: $frontendTypes.FootprintApiManager.DatexAdjustmentInfo, AddressEntityTypes?: string[] }> {
    if(!this._footprint_generic_json_adjustment_schema) { 
      this._footprint_generic_json_adjustment_schema = this.injector.get(FootprintApiManager_footprint_generic_json_adjustment_schemaService);
    }
    return this._footprint_generic_json_adjustment_schema.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_to_entity_import_flow: FootprintApiManager_footprint_generic_json_adjustment_to_entity_import_flowService;
  public async footprint_generic_json_adjustment_to_entity_import_flow($inParams: { adjustment?: any, transaction_id?: string, source_platform?: string }): Promise< { payloads?: any[], messages?: string[], warehouse?: string, project?: string }> {
    if(!this._footprint_generic_json_adjustment_to_entity_import_flow) { 
      this._footprint_generic_json_adjustment_to_entity_import_flow = this.injector.get(FootprintApiManager_footprint_generic_json_adjustment_to_entity_import_flowService);
    }
    return this._footprint_generic_json_adjustment_to_entity_import_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_check_import_requests: FootprintApiManager_footprint_generic_json_check_import_requestsService;
  public async footprint_generic_json_check_import_requests($inParams: { request_ids?: string[] }): Promise< { results?: { requestId?: string, project?: string, warehouse?: string, referenceCode?: string, status?: string, errorMessage?: string }[] }> {
    if(!this._footprint_generic_json_check_import_requests) { 
      this._footprint_generic_json_check_import_requests = this.injector.get(FootprintApiManager_footprint_generic_json_check_import_requestsService);
    }
    return this._footprint_generic_json_check_import_requests.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_get_completed_orders_flow: FootprintApiManager_footprint_generic_json_get_completed_orders_flowService;
  public async footprint_generic_json_get_completed_orders_flow($inParams: { shipped_date?: string, order_types?: string[], projects?: string[], has_transmission?: boolean }): Promise< { messages?: any[], orders?: { order_id?: number, order_lookup?: string, shipment_id?: number, project_id?: number, project_lookup?: string, shipped_date?: string }[] }> {
    if(!this._footprint_generic_json_get_completed_orders_flow) { 
      this._footprint_generic_json_get_completed_orders_flow = this.injector.get(FootprintApiManager_footprint_generic_json_get_completed_orders_flowService);
    }
    return this._footprint_generic_json_get_completed_orders_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_inventory_export_data: FootprintApiManager_footprint_generic_json_inventory_export_dataService;
  public async footprint_generic_json_inventory_export_data($inParams: { project_lookup_code?: string, material_lookup_code?: string, warehouse_name?: string, render_lots?: boolean, render_license_plates?: boolean, render_serial_numbers?: boolean, debug?: boolean, only_inventory?: boolean, only_physical?: boolean, date_format?: string }): Promise< { DatexInventoryInfo?: $frontendTypes.FootprintApiManager.DatexInventoryInfo, messages?: any[] }> {
    if(!this._footprint_generic_json_inventory_export_data) { 
      this._footprint_generic_json_inventory_export_data = this.injector.get(FootprintApiManager_footprint_generic_json_inventory_export_dataService);
    }
    return this._footprint_generic_json_inventory_export_data.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_inventory_export_flow: FootprintApiManager_footprint_generic_json_inventory_export_flowService;
  public async footprint_generic_json_inventory_export_flow($inParams: { project_lookup_code?: string, material_lookup_code?: string, warehouse_name?: string, render_lots?: boolean, render_license_plates?: boolean, render_serial_numbers?: boolean, integration_name?: string, transaction_id?: string }): Promise< { messages?: string[], DatexInventoryInfo?: $frontendTypes.FootprintApiManager.DatexInventoryInfo }> {
    if(!this._footprint_generic_json_inventory_export_flow) { 
      this._footprint_generic_json_inventory_export_flow = this.injector.get(FootprintApiManager_footprint_generic_json_inventory_export_flowService);
    }
    return this._footprint_generic_json_inventory_export_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_inventory_export_to_xml: FootprintApiManager_footprint_generic_json_inventory_export_to_xmlService;
  public async footprint_generic_json_inventory_export_to_xml($inParams: { DatexInventoryInfo?: $frontendTypes.FootprintApiManager.DatexInventoryInfo }): Promise< { DatexInventoryInfoXml?: string }> {
    if(!this._footprint_generic_json_inventory_export_to_xml) { 
      this._footprint_generic_json_inventory_export_to_xml = this.injector.get(FootprintApiManager_footprint_generic_json_inventory_export_to_xmlService);
    }
    return this._footprint_generic_json_inventory_export_to_xml.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_inventory_schema: FootprintApiManager_footprint_generic_json_inventory_schemaService;
  public async footprint_generic_json_inventory_schema($inParams: { example?: boolean }): Promise< { DatexInventoryInfo?: { Projects?: any[], Warehouses?: any[] }, Addresses?: { EntityType?: string, AccountType?: string, ContactType?: string, AlternateEmail?: string, AlternateFax?: string, AlternateTelephone?: string, AttentionOf?: string, City?: string, Country?: string, FirstName?: string, Greeting?: string, IsResidential?: string, LastName?: string, Line1?: string, Line2?: string, Line3?: string, Line4?: string, LookupCode?: string, MiddleName?: string, Name?: string, Notes?: string, PostalCode?: string, PrimaryEmail?: string, PrimaryFax?: string, PrimaryTelephone?: string, ReferenceCode?: string, State?: string, Title?: string, Url?: string, UserDefinedFields?: any[] }[], Warehouses?: { WarehouseName?: string, Addresses?: any[], UserDefinedFields?: any[], InventoryByWarehouse?: any }[], InventoryByWarehouse?: { InventoryByMaterial?: any[] }, InventoryByMaterial?: { Material?: any, InventoryByMaterialPackaging?: any[] }[], InventoryByMaterialPackaging?: { MaterialPackaging?: any, InventorySummary?: any, InventoryByMaterialLot?: any[] }[], InventoryByMaterialLot?: { Lot?: any, InventorySummary?: any, InventoryByLicensePlateLot?: any[] }[], InventoryByLicensePlateLot?: { LicensePlate?: any, InventorySummary?: any }[], Projects?: { OwnerLookupCode?: string, OwnerName?: string, ProjectLookupCode?: string, ProjectName?: string, Addresses?: any[], UserDefinedFields?: any[] }[], InventorySummary?: { ActiveAmount?: string, ActivePackagedAmount?: string, AllocatedAmount?: string, AllocatedPackagedAmount?: string, AvailableAmount?: string, AvailablePackagedAmount?: string, CurrentlyAvailableAmount?: string, CurrentlyAvailablePackagedAmount?: string, InactiveAmount?: string, InactivePackagedAmount?: string, IncomingAmount?: string, IncomingPackagedAmount?: string, SoftAllocatedAmount?: string, SoftAllocatedPackagedAmount?: string, SoftIncomingAmount?: string, SoftIncomingPackagedAmount?: string, TotalAmount?: string, TotalPackagedAmount?: string, GrossVolume?: string, NetVolume?: string, VolumeUom?: string, GrossWeight?: string, NetWeight?: string, WeightUom?: string }, UserDefinedFields?: { Name?: string, Value?: string }[], ReasonCodes?: { Label?: string, LookupCode?: string, Name?: string }[], Material?: { ControllerType?: string, Description?: string, GlobalMaterial?: string, IsFixedWeight?: string, KitType?: string, LookupCode?: string, MaterialGroup?: string, Name?: string, NmfcNumber?: string, NmfcSubNumber?: string, ShelfLifeSpan?: string, StandardCost?: string, StandardPrice?: string, Status?: string, ValuationMethod?: string, UserDefinedFields?: any[] }, MaterialPackaging?: { BasePackagingQuantity?: string, DimensionUom?: string, Height?: string, Length?: string, PackagingName?: string, PackagingShortName?: string, PalletHigh?: string, PalletTie?: string, ShippingVolume?: string, ShippingWeight?: string, StandardCost?: string, StandardPrice?: string, SubPackagingQuantity?: string, TareWeight?: string, UpcCode?: string, Volume?: string, VolumeUom?: string, Weight?: string, WeightUom?: string, Width?: string }, Lot?: { Description?: string, LastReceiveDate?: string, LookupCode?: string, Notes?: string, ReceiveDate?: string, Status?: string, VendorLotDescription?: string, ExpirationDate?: string, ExpirationNotificationDateOverride?: string, ExpirationNotificationOverride?: string, VendorLotLookupCode?: string, ManufactureDate?: string, VendorLotNotes?: string, Vat?: string, ReasonCodes?: any[], UserDefinedFields?: any[] }, LicensePlate?: { DimensionsUom?: string, Height?: string, Length?: string, Location?: string, LocationStatus?: string, LookupCode?: string, MaximumWeight?: string, Status?: string, Width?: string, ReasonCodes?: any[], UserDefinedFields?: any[], SerialNumbers?: any[] }, SerialNumbers?: { DimensionUom?: string, GrossVolume?: string, GrossWeight?: string, Height?: string, Length?: string, LookupCode?: string, NetVolume?: string, NetWeight?: string, Notes?: string, PackagingName?: string, PackagingShortName?: string, Status?: string, VolumeUom?: string, WeightUom?: string, Width?: string, ChildSerialNumbers?: any[], UserDefinedFields?: any[] }[], AddressEntityTypes?: string[] }> {
    if(!this._footprint_generic_json_inventory_schema) { 
      this._footprint_generic_json_inventory_schema = this.injector.get(FootprintApiManager_footprint_generic_json_inventory_schemaService);
    }
    return this._footprint_generic_json_inventory_schema.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_invoice_export_data: FootprintApiManager_footprint_generic_json_invoice_export_dataService;
  public async footprint_generic_json_invoice_export_data($inParams: { invoice_id?: number, date_format?: string }): Promise< { DatexInvoiceInfo?: $frontendTypes.FootprintApiManager.DatexInvoiceInfo, invoice_id?: number, messages?: any[] }> {
    if(!this._footprint_generic_json_invoice_export_data) { 
      this._footprint_generic_json_invoice_export_data = this.injector.get(FootprintApiManager_footprint_generic_json_invoice_export_dataService);
    }
    return this._footprint_generic_json_invoice_export_data.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_invoice_export_flow: FootprintApiManager_footprint_generic_json_invoice_export_flowService;
  public async footprint_generic_json_invoice_export_flow($inParams: { invoice_id?: number, integration_name?: string, transaction_id?: string, invoice_lookup?: string }): Promise< { messages?: string[], DatexInvoiceInfo?: $frontendTypes.FootprintApiManager.DatexInvoiceInfo }> {
    if(!this._footprint_generic_json_invoice_export_flow) { 
      this._footprint_generic_json_invoice_export_flow = this.injector.get(FootprintApiManager_footprint_generic_json_invoice_export_flowService);
    }
    return this._footprint_generic_json_invoice_export_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_invoice_schema: FootprintApiManager_footprint_generic_json_invoice_schemaService;
  public async footprint_generic_json_invoice_schema($inParams: { example?: boolean, map?: boolean }): Promise< { DatexInvoiceInfo?: $frontendTypes.FootprintApiManager.DatexInvoiceInfo }> {
    if(!this._footprint_generic_json_invoice_schema) { 
      this._footprint_generic_json_invoice_schema = this.injector.get(FootprintApiManager_footprint_generic_json_invoice_schemaService);
    }
    return this._footprint_generic_json_invoice_schema.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_material_import_flow: FootprintApiManager_footprint_generic_json_material_import_flowService;
  public async footprint_generic_json_material_import_flow($inParams: { materials?: $frontendTypes.FootprintApiManager.DatexMaterialInfo[], transaction_id?: string, ingress_id?: string, integration_name?: string }): Promise< { messages?: any[], results?: { requestId?: string, referenceCode?: string, project?: string, message?: string, entities?: any, transactionId?: string }[], reasons?: string[] }> {
    if(!this._footprint_generic_json_material_import_flow) { 
      this._footprint_generic_json_material_import_flow = this.injector.get(FootprintApiManager_footprint_generic_json_material_import_flowService);
    }
    return this._footprint_generic_json_material_import_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_material_to_entity_import_xml_flow: FootprintApiManager_footprint_generic_json_material_to_entity_import_xml_flowService;
  public async footprint_generic_json_material_to_entity_import_xml_flow($inParams: { material?: $frontendTypes.FootprintApiManager.DatexMaterialInfo, transaction_id?: string, source_lookup_code?: string, source_platform?: string }): Promise< { messages?: string[], project?: string, payload_xml?: string, payload_json?: any }> {
    if(!this._footprint_generic_json_material_to_entity_import_xml_flow) { 
      this._footprint_generic_json_material_to_entity_import_xml_flow = this.injector.get(FootprintApiManager_footprint_generic_json_material_to_entity_import_xml_flowService);
    }
    return this._footprint_generic_json_material_to_entity_import_xml_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_export_data: FootprintApiManager_footprint_generic_json_order_export_dataService;
  public async footprint_generic_json_order_export_data($inParams: { shipmentId?: number, orderId?: number, dateFormat?: string }): Promise< { DatexOrderInfo?: $frontendTypes.FootprintApiManager.DatexOrderInfo, orderId?: number }> {
    if(!this._footprint_generic_json_order_export_data) { 
      this._footprint_generic_json_order_export_data = this.injector.get(FootprintApiManager_footprint_generic_json_order_export_dataService);
    }
    return this._footprint_generic_json_order_export_data.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_export_flow: FootprintApiManager_footprint_generic_json_order_export_flowService;
  public async footprint_generic_json_order_export_flow($inParams: { shipment_id?: number, integration_name?: string, transaction_id?: string, order_lookup?: string, set_transmission?: boolean }): Promise< { messages?: string[], DatexOrderInfo?: $frontendTypes.FootprintApiManager.DatexOrderInfo }> {
    if(!this._footprint_generic_json_order_export_flow) { 
      this._footprint_generic_json_order_export_flow = this.injector.get(FootprintApiManager_footprint_generic_json_order_export_flowService);
    }
    return this._footprint_generic_json_order_export_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_export_to_xml: FootprintApiManager_footprint_generic_json_order_export_to_xmlService;
  public async footprint_generic_json_order_export_to_xml($inParams: { DatexOrderInfo?: $frontendTypes.FootprintApiManager.DatexOrderInfo }): Promise< { DatexOrderInfoXml?: string }> {
    if(!this._footprint_generic_json_order_export_to_xml) { 
      this._footprint_generic_json_order_export_to_xml = this.injector.get(FootprintApiManager_footprint_generic_json_order_export_to_xmlService);
    }
    return this._footprint_generic_json_order_export_to_xml.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_import_flow: FootprintApiManager_footprint_generic_json_order_import_flowService;
  public async footprint_generic_json_order_import_flow($inParams: { orders?: $frontendTypes.FootprintApiManager.DatexOrderInfo[], transaction_id?: string, ingress_id?: string, source_lookup_code?: string, source_platform?: string, order_type?: string, order_action?: string, account_action?: string, submitAsync?: boolean, integration_name?: string, environment?: string, sender?: string, receiver?: string, debug?: boolean }): Promise< { messages?: any[], results?: { requestId?: string, orderId?: string, referenceCode?: string, project?: string, warehouse?: string, message?: string, order?: any, entities?: any, transactionId?: string }[], reasons?: string[] }> {
    if(!this._footprint_generic_json_order_import_flow) { 
      this._footprint_generic_json_order_import_flow = this.injector.get(FootprintApiManager_footprint_generic_json_order_import_flowService);
    }
    return this._footprint_generic_json_order_import_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_schema: FootprintApiManager_footprint_generic_json_order_schemaService;
  public async footprint_generic_json_order_schema($inParams: { example?: boolean, map?: boolean }): Promise< { DatexOrderInfo?: $frontendTypes.FootprintApiManager.DatexOrderInfo, Addresses?: $frontendTypes.FootprintApiManager.Address[], Shipments?: $frontendTypes.FootprintApiManager.Shipment[], Conveyance?: $frontendTypes.FootprintApiManager.Conveyance, ShipmentTotals?: $frontendTypes.FootprintApiManager.ShipmentTotals, Orders?: $frontendTypes.FootprintApiManager.Order[], OrderLines?: $frontendTypes.FootprintApiManager.OrderLine[], DockAppointments?: $frontendTypes.FootprintApiManager.DockAppointment[], UserDefinedFields?: $frontendTypes.FootprintApiManager.UserDefinedField[], ReasonCodes?: $frontendTypes.FootprintApiManager.ReasonCode[], Material?: $frontendTypes.FootprintApiManager.Material, MaterialPackaging?: $frontendTypes.FootprintApiManager.MaterialPackaging, Lot?: $frontendTypes.FootprintApiManager.Lot, ShippingContainer?: $frontendTypes.FootprintApiManager.ShippingContainer, LicensePlates?: $frontendTypes.FootprintApiManager.LicensePlate[], LicensePlateContents?: $frontendTypes.FootprintApiManager.LicensePlateContent[], SerialNumbers?: $frontendTypes.FootprintApiManager.SerialNumber[], WavelengthConnectorTransmissions?: $frontendTypes.FootprintApiManager.WavelengthConnectorTransmission[], PalletTransactions?: $frontendTypes.FootprintApiManager.PalletTransaction[], AddressEntityTypes?: string[] }> {
    if(!this._footprint_generic_json_order_schema) { 
      this._footprint_generic_json_order_schema = this.injector.get(FootprintApiManager_footprint_generic_json_order_schemaService);
    }
    return this._footprint_generic_json_order_schema.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_summary_data: FootprintApiManager_footprint_generic_json_order_summary_dataService;
  public async footprint_generic_json_order_summary_data($inParams: { shipment_id?: number, transaction_id?: string }): Promise< { DatexOrderSummary?: { Orders?: any[] } }> {
    if(!this._footprint_generic_json_order_summary_data) { 
      this._footprint_generic_json_order_summary_data = this.injector.get(FootprintApiManager_footprint_generic_json_order_summary_dataService);
    }
    return this._footprint_generic_json_order_summary_data.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_to_crud_batch_request_flow: FootprintApiManager_footprint_generic_json_order_to_crud_batch_request_flowService;
  public async footprint_generic_json_order_to_crud_batch_request_flow($inParams: { order?: any, transaction_id?: string, source_lookup_code?: string, source_platform?: string, order_type?: string, order_action?: string, account_action?: string }): Promise< { entities?: { method: string, set: string, keys?: { name: string, value: any }[], properties?: any }[], messages?: string[], warehouse?: string, project?: string, referenceCode?: string, reasons?: string[] }> {
    if(!this._footprint_generic_json_order_to_crud_batch_request_flow) { 
      this._footprint_generic_json_order_to_crud_batch_request_flow = this.injector.get(FootprintApiManager_footprint_generic_json_order_to_crud_batch_request_flowService);
    }
    return this._footprint_generic_json_order_to_crud_batch_request_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_to_entity_import_flow: FootprintApiManager_footprint_generic_json_order_to_entity_import_flowService;
  public async footprint_generic_json_order_to_entity_import_flow($inParams: { order?: $frontendTypes.FootprintApiManager.DatexOrderInfo, transaction_id?: string, source_lookup_code?: string, source_platform?: string, order_type?: string, order_action?: string, account_action?: string }): Promise< { payload?: any[], messages?: string[], warehouse?: string, project?: string, referenceCode?: string }> {
    if(!this._footprint_generic_json_order_to_entity_import_flow) { 
      this._footprint_generic_json_order_to_entity_import_flow = this.injector.get(FootprintApiManager_footprint_generic_json_order_to_entity_import_flowService);
    }
    return this._footprint_generic_json_order_to_entity_import_flow.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_shipment_contents: FootprintApiManager_footprint_generic_json_shipment_contentsService;
  public async footprint_generic_json_shipment_contents($inParams: { shipmentId: number, orderId?: number, typeId: number }): Promise< { result?: { ShipmentId?: number, ShipmentLineId?: number, OrderId?: number, OrderLineNumber?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, LicensePlate?: { Id?: number, DimensionsUomId?: number, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, MaximumWeight?: number, NetVolume?: number, NetWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, ShippingContainer?: { Id?: number, BillOfLading?: string, BondNumber?: string, CommodityDescription?: string, ContainerNumber?: string, CustomsReleaseNumber?: string, DeclaredValue?: number, EstimatedDeliveryDateTime?: string, Height?: number, Length?: number, LookupCode?: string, ManifestedPackageBundleCode?: string, ManifestedPackageCode?: string, NmfcNumber?: string, NmfcSubNumber?: string, Notes?: string, PackagedItemCount?: number, SailOnBoard?: string, SealId?: string, ShippingCost?: number, ShippingDate?: string, TrackingNumber?: string, TrailerNumber?: string, Volume?: number, Weight?: number, Width?: number, Carrier?: { Name?: string, ScacCode?: string, ShortName?: string }, CarrierServiceType?: { Name?: string, ShortName?: string }, DimensionUom?: { Short_name?: string }, FreightClass?: { Name?: string }, ContainerSize?: { Name?: string }, ContainerType?: { Name?: string }, VolumeUom?: { Short_name?: string }, WeightUom?: { Short_name?: string } }, Location?: { Name?: string, Status?: { Name?: string } }, Status?: { Name?: string }, ContainerType?: { Name?: string } }, Lot?: { Id?: number, Description?: string, LastReceiveDate?: string, LookupCode?: string, Notes?: string, ReceiveDate?: string, VendorLot?: { Id?: number, Description?: string, ExpirationDate?: string, ExpirationNotificationDateOverride?: string, ExpirationNotificationOverride?: boolean, LookupCode?: string, ManufactureDate?: string, Notes?: string, Vat?: string }, Material?: { Id?: number, PackagingLookups?: { PackagingId?: number, BasePackagingQuantity?: number, SubPackagingQuantity?: number }[] }, Status?: { Name?: string } }, Packaging?: { Id?: number, Name?: string, ShortName?: string } }[], totalCount?: number }> {
    if(!this._footprint_generic_json_shipment_contents) { 
      this._footprint_generic_json_shipment_contents = this.injector.get(FootprintApiManager_footprint_generic_json_shipment_contentsService);
    }
    return this._footprint_generic_json_shipment_contents.run($inParams);
  }
   
   

   
 
  private _footprint_generic_serial_numbers: FootprintApiManager_footprint_generic_serial_numbersService;
  public async footprint_generic_serial_numbers($inParams: { project_lookup_code?: string, material_lookup_code?: string, packaged_amount?: number, packaging_short_name?: string, net_weight?: number, gross_weight?: number, weight_uom?: string }): Promise< { serial_numbers?: $frontendTypes.FootprintApiManager.SerialNumber[] }> {
    if(!this._footprint_generic_serial_numbers) { 
      this._footprint_generic_serial_numbers = this.injector.get(FootprintApiManager_footprint_generic_serial_numbersService);
    }
    return this._footprint_generic_serial_numbers.run($inParams);
  }
   
   

   
 
  private _footprint_json_entity_import_entity_schema: FootprintApiManager_footprint_json_entity_import_entity_schemaService;
  public async footprint_json_entity_import_entity_schema($inParams: { example?: boolean }): Promise< { entity_schema?: { Type?: string, ReferenceKey?: string, Action?: string, MatchCriteria?: { Limit?: number, Criteria?: { Type?: string, PropertyName?: string, Value?: string }[], OrderBy?: { PropertyName?: string, Direction?: string }[] }, Conditions?: { Type?: string, Group?: number, Test?: string, Value?: string }[], Properties?: { Name?: string, Value?: string, EvaluateAsExpression?: string, Update?: string }[], UserDefinedFields?: { Name?: string, Values?: string[] }[], IsValidation?: string }, workflow_schema?: { WorkflowCode?: string, ReferenceKey?: string, Parameters?: { Name?: string, Value?: string, OnAlert?: string }[] } }> {
    if(!this._footprint_json_entity_import_entity_schema) { 
      this._footprint_json_entity_import_entity_schema = this.injector.get(FootprintApiManager_footprint_json_entity_import_entity_schemaService);
    }
    return this._footprint_json_entity_import_entity_schema.run($inParams);
  }
   
   

   
 
  private _footprint_manage_wavelength_transmissions: FootprintApiManager_footprint_manage_wavelength_transmissionsService;
  public async footprint_manage_wavelength_transmissions($inParams: { entity: string, id: number, action: string, transaction_id?: string, integration_id?: string, transmission_type?: string, transmission_direction?: string, notes?: string, transmission_id?: number, type_id?: number, integration_name?: string }): Promise< { success?: boolean, messages?: string[], transmission_id?: number }> {
    if(!this._footprint_manage_wavelength_transmissions) { 
      this._footprint_manage_wavelength_transmissions = this.injector.get(FootprintApiManager_footprint_manage_wavelength_transmissionsService);
    }
    return this._footprint_manage_wavelength_transmissions.run($inParams);
  }
   
   

   
 
  private _get_accounts: FootprintApiManager_get_accountsService;
  public async get_accounts($inParams: { filters: { account_ids?: number[], account_lookups?: string[], account_names?: string[] } }): Promise< { accounts?: $frontendTypes.FootprintApiManager.public_account[], errors?: string[] }> {
    if(!this._get_accounts) { 
      this._get_accounts = this.injector.get(FootprintApiManager_get_accountsService);
    }
    return this._get_accounts.run($inParams);
  }
   
   

   
 
  private _get_accounts_flow: FootprintApiManager_get_accounts_flowService;
  public async get_accounts_flow($inParams: { filters: { account_ids?: number[], account_lookups?: string[], account_names?: string[], owner_id?: number, owner_lookup?: string } }): Promise< { accounts?: $frontendTypes.FootprintApiManager.public_account[], errors?: string[] }> {
    if(!this._get_accounts_flow) { 
      this._get_accounts_flow = this.injector.get(FootprintApiManager_get_accounts_flowService);
    }
    return this._get_accounts_flow.run($inParams);
  }
   
   

   
 
  private _get_asn_orders: FootprintApiManager_get_asn_ordersService;
  public async get_asn_orders($inParams: { filters?: $frontendTypes.FootprintApiManager.input_get_asn_order, paging?: { top?: number, skip?: number } }): Promise< { orders?: $frontendTypes.FootprintApiManager.public_order[] }> {
    if(!this._get_asn_orders) { 
      this._get_asn_orders = this.injector.get(FootprintApiManager_get_asn_ordersService);
    }
    return this._get_asn_orders.run($inParams);
  }
   
   

   
 
  private _get_asn_orders_flow: FootprintApiManager_get_asn_orders_flowService;
  public async get_asn_orders_flow($inParams: { filters?: { owner?: string, project?: string, warehouse?: string, status?: string, lookup?: string, owner_reference?: string, vendor_reference?: string, order_id?: number, created_from?: string, created_to?: string, fulfilled_from?: string, fulfilled_to?: string, order_class_type?: string }, paging?: { top?: number, skip?: number }, exclude?: { shipments?: boolean, order_lines?: boolean, addresses?: boolean, shipped_contents?: boolean, tasks?: boolean } }): Promise< { orders?: $frontendTypes.FootprintApiManager.public_order[] }> {
    if(!this._get_asn_orders_flow) { 
      this._get_asn_orders_flow = this.injector.get(FootprintApiManager_get_asn_orders_flowService);
    }
    return this._get_asn_orders_flow.run($inParams);
  }
   
   

   
 
  private _get_carriers_flow: FootprintApiManager_get_carriers_flowService;
  public async get_carriers_flow($inParams: { filters: { carrier_name?: string, carrier_short_name?: string, scac?: string, carrier_id?: number } }): Promise< { carriers?: $frontendTypes.FootprintApiManager.public_carrier[], errors?: string[] }> {
    if(!this._get_carriers_flow) { 
      this._get_carriers_flow = this.injector.get(FootprintApiManager_get_carriers_flowService);
    }
    return this._get_carriers_flow.run($inParams);
  }
   
   

   
 
  private _get_configuration: FootprintApiManager_get_configurationService;
  public async get_configuration($inParams: { name?: string, value?: string, notes?: string, integration_name?: string, user_name?: string, id?: string, encrypt?: boolean }): Promise< { value?: string }> {
    if(!this._get_configuration) { 
      this._get_configuration = this.injector.get(FootprintApiManager_get_configurationService);
    }
    return this._get_configuration.run($inParams);
  }
   
   

   
 
  private _get_configuration_examples: FootprintApiManager_get_configuration_examplesService;
  public async get_configuration_examples($inParams: { purge?: boolean }): Promise< { results?: any[] }> {
    if(!this._get_configuration_examples) { 
      this._get_configuration_examples = this.injector.get(FootprintApiManager_get_configuration_examplesService);
    }
    return this._get_configuration_examples.run($inParams);
  }
   
   

   
 
  private _get_contacts_flow: FootprintApiManager_get_contacts_flowService;
  public async get_contacts_flow($inParams: { filters: { contact_ids?: number[], owner_entities?: string[], address_ids?: number[], first_names?: string[], last_names?: string[] } }): Promise< { contacts?: $frontendTypes.FootprintApiManager.public_contact[], errors?: string[] }> {
    if(!this._get_contacts_flow) { 
      this._get_contacts_flow = this.injector.get(FootprintApiManager_get_contacts_flowService);
    }
    return this._get_contacts_flow.run($inParams);
  }
   
   

   
 
  private _get_date_from_footprint: FootprintApiManager_get_date_from_footprintService;
  public async get_date_from_footprint($inParams: {  }): Promise< { date_local?: string, date_utc?: string }> {
    if(!this._get_date_from_footprint) { 
      this._get_date_from_footprint = this.injector.get(FootprintApiManager_get_date_from_footprintService);
    }
    return this._get_date_from_footprint.run($inParams);
  }
   
   

   
 
  private _get_inventory: FootprintApiManager_get_inventoryService;
  public async get_inventory($inParams: { aggregation_level?: string, filters?: $frontendTypes.FootprintApiManager.input_get_inventory, paging?: { top?: number, skip?: number } }): Promise< { aggregation_level?: string, inventory?: $frontendTypes.FootprintApiManager.public_inventory[], paging?: { total_records?: number, returned_records?: number, top?: number, skip?: number } }> {
    if(!this._get_inventory) { 
      this._get_inventory = this.injector.get(FootprintApiManager_get_inventoryService);
    }
    return this._get_inventory.run($inParams);
  }
   
   

   
 
  private _get_inventory_adjustments_flow: FootprintApiManager_get_inventory_adjustments_flowService;
  public async get_inventory_adjustments_flow($inParams: { filters?: { material?: string, vendor_lot?: string, lot?: string, project?: string, owner?: string, license_plate?: string, location?: string, warehouse?: string, packaging?: string, completed_from?: string, completed_to?: string }, as_export?: boolean, paging?: { skip?: number, top?: number } }): Promise< { paging?: { total_records?: number, skip?: number, top?: number, message?: string }, adjustments?: { owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, warehouse?: string, location?: string, license_plate?: string, serial_numbers?: string[], completed_on?: string, packaged_amount?: number }[] }> {
    if(!this._get_inventory_adjustments_flow) { 
      this._get_inventory_adjustments_flow = this.injector.get(FootprintApiManager_get_inventory_adjustments_flowService);
    }
    return this._get_inventory_adjustments_flow.run($inParams);
  }
   
   

   
 
  private _get_inventory_flow: FootprintApiManager_get_inventory_flowService;
  public async get_inventory_flow($inParams: { paging?: { page: number, total: number }, warehouse: string, filters?: { owner?: string, project?: string, material?: string, lot?: string, vendor_lot?: string, upc?: string }, output_weight_uom?: string }): Promise< { paging?: { total_records?: number, total_pages?: number, page?: number, returned_records?: number }, results?: { owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, license_plate?: string, is_fixed_weight?: boolean, packaging_net_weight?: number, packaging_gross_weight?: number, total_net_weight?: number, total_gross_weight?: number, weight_uom?: string, serial_numbers?: { lookup?: string, net_weight?: string, gross_weight?: string, weight_uom?: string }[] }[] }> {
    if(!this._get_inventory_flow) { 
      this._get_inventory_flow = this.injector.get(FootprintApiManager_get_inventory_flowService);
    }
    return this._get_inventory_flow.run($inParams);
  }
   
   

   
 
  private _get_lots_flow: FootprintApiManager_get_lots_flowService;
  public async get_lots_flow($inParams: { paging?: { top?: number, skip?: number }, filters?: { vendor_lot_id?: number, lookup?: string, material_id?: number, material_lookup?: string, project_id?: number, project_lookup?: string, owner_id?: number, owner_lookup?: string, receive_date_from?: string, receive_date_to?: string, last_receive_date_from?: string, last_receive_date_to?: string, vendor_lot_lookup?: string, lot_id?: number }, exclude?: { user_defined_fields?: boolean } }): Promise< { lots?: $frontendTypes.FootprintApiManager.public_lot[], errors?: string[] }> {
    if(!this._get_lots_flow) { 
      this._get_lots_flow = this.injector.get(FootprintApiManager_get_lots_flowService);
    }
    return this._get_lots_flow.run($inParams);
  }
   
   

   
 
  private _get_materials_flow: FootprintApiManager_get_materials_flowService;
  public async get_materials_flow($inParams: { filters: { owner?: string[], project?: string[], status?: string[], lookup?: string[], global_material_name?: string[], material_name?: string[], material_group?: string[], material_id?: number[], fulfilled_from?: string, fulfilled_to?: string } }): Promise< { materials?: $frontendTypes.FootprintApiManager.public_material[], errors?: string[] }> {
    if(!this._get_materials_flow) { 
      this._get_materials_flow = this.injector.get(FootprintApiManager_get_materials_flowService);
    }
    return this._get_materials_flow.run($inParams);
  }
   
   

   
 
  private _get_order_addresses_flow: FootprintApiManager_get_order_addresses_flowService;
  public async get_order_addresses_flow($inParams: { order_ids: number[] }): Promise< { order_addresses?: $frontendTypes.FootprintApiManager.public_order_address[], errors?: string[] }> {
    if(!this._get_order_addresses_flow) { 
      this._get_order_addresses_flow = this.injector.get(FootprintApiManager_get_order_addresses_flowService);
    }
    return this._get_order_addresses_flow.run($inParams);
  }
   
   

   
 
  private _get_orders_order_addresses_flow: FootprintApiManager_get_orders_order_addresses_flowService;
  public async get_orders_order_addresses_flow($inParams: { order_ids: number[] }): Promise< { order_addresses?: $frontendTypes.FootprintApiManager.public_order_address[], errors?: string[] }> {
    if(!this._get_orders_order_addresses_flow) { 
      this._get_orders_order_addresses_flow = this.injector.get(FootprintApiManager_get_orders_order_addresses_flowService);
    }
    return this._get_orders_order_addresses_flow.run($inParams);
  }
   
   

   
 
  private _get_outbound_orders_confirmation: FootprintApiManager_get_outbound_orders_confirmationService;
  public async get_outbound_orders_confirmation($inParams: { outbound_order_ids: number[] }): Promise< { outbound_order_shipping_containers: { outbound_order?: $frontendTypes.FootprintApiManager.public_order, shipping_info?: { shipment?: $frontendTypes.FootprintApiManager.public_shipment, shipping_containers?: $frontendTypes.FootprintApiManager.public_shipping_container[] }, message?: string }[], errors?: string[] }> {
    if(!this._get_outbound_orders_confirmation) { 
      this._get_outbound_orders_confirmation = this.injector.get(FootprintApiManager_get_outbound_orders_confirmationService);
    }
    return this._get_outbound_orders_confirmation.run($inParams);
  }
   
   

   
 
  private _get_purchase_orders_flow: FootprintApiManager_get_purchase_orders_flowService;
  public async get_purchase_orders_flow($inParams: { filters?: { owner?: string, project?: string, warehouse?: string, status?: string, lookup?: string, owner_reference?: string, vendor_reference?: string, order_id?: number, created_from?: string, created_to?: string, fulfilled_from?: string, fulfilled_to?: string, order_class_type?: string }, paging?: { top?: number, skip?: number }, exclude?: { shipments?: boolean, order_lines?: boolean, addresses?: boolean, shipped_contents?: boolean, tasks?: boolean }, as_export?: boolean }): Promise< { orders?: $frontendTypes.FootprintApiManager.public_order[] }> {
    if(!this._get_purchase_orders_flow) { 
      this._get_purchase_orders_flow = this.injector.get(FootprintApiManager_get_purchase_orders_flowService);
    }
    return this._get_purchase_orders_flow.run($inParams);
  }
   
   

   
 
  private _get_reason_codes: FootprintApiManager_get_reason_codesService;
  public async get_reason_codes($inParams: { entity: string, id: number }): Promise< { reasonCodeIds?: number[], reasonCodes?: { Id?: number, Label?: string, LookupCode?: string, Name?: string }[] }> {
    if(!this._get_reason_codes) { 
      this._get_reason_codes = this.injector.get(FootprintApiManager_get_reason_codesService);
    }
    return this._get_reason_codes.run($inParams);
  }
   
   

   
 
  private _get_report_data_flow: FootprintApiManager_get_report_data_flowService;
  public async get_report_data_flow($inParams: { package_name: string, report_name: string, inputs?: any }): Promise< { report_data?: Blob }> {
    if(!this._get_report_data_flow) { 
      this._get_report_data_flow = this.injector.get(FootprintApiManager_get_report_data_flowService);
    }
    return this._get_report_data_flow.run($inParams);
  }
   
   

   
 
  private _get_return_notifications: FootprintApiManager_get_return_notificationsService;
  public async get_return_notifications($inParams: { order_ids: number[] }): Promise< { return_notifications?: { date?: string, employee?: string, order?: string, contact?: $frontendTypes.FootprintApiManager.public_contact, return_items?: { material?: string, quantity?: number, packaging?: string, serialized?: boolean, serial_number?: string }[], order_id?: number }[], errors?: string[] }> {
    if(!this._get_return_notifications) { 
      this._get_return_notifications = this.injector.get(FootprintApiManager_get_return_notificationsService);
    }
    return this._get_return_notifications.run($inParams);
  }
   
   

   
 
  private _get_sales_orders_flow: FootprintApiManager_get_sales_orders_flowService;
  public async get_sales_orders_flow($inParams: { filters?: { owner?: string, project?: string, warehouse?: string, status?: string, lookup?: string, owner_reference?: string, vendor_reference?: string, order_id?: number, created_from?: string, created_to?: string, fulfilled_from?: string, fulfilled_to?: string }, paging?: { top?: number, skip?: number }, exclude?: { shipments?: boolean, order_lines?: boolean, addresses?: boolean, shipped_contents?: boolean, tasks?: boolean, instructions?: boolean, transmissions?: { direction_name?: string, type_name?: string }, user_defined_fields?: boolean }, as_export?: boolean }): Promise< { paging: { total_records: number, returned_records: number, top: number, skip: number }, orders?: $frontendTypes.FootprintApiManager.public_order[] }> {
    if(!this._get_sales_orders_flow) { 
      this._get_sales_orders_flow = this.injector.get(FootprintApiManager_get_sales_orders_flowService);
    }
    return this._get_sales_orders_flow.run($inParams);
  }
   
   

   
 
  private _get_serial_numbers_flow: FootprintApiManager_get_serial_numbers_flowService;
  public async get_serial_numbers_flow($inParams: { owner?: string, project?: string, material?: string, vendor_lot?: string, lot?: string, license_plate?: string, lookup?: string, is_archived?: boolean, warehouse?: string, top?: number, skip?: number }): Promise< { serial_numbers?: $frontendTypes.FootprintApiManager.public_serial_number[] }> {
    if(!this._get_serial_numbers_flow) { 
      this._get_serial_numbers_flow = this.injector.get(FootprintApiManager_get_serial_numbers_flowService);
    }
    return this._get_serial_numbers_flow.run($inParams);
  }
   
   

   
 
  private _get_user_defined_field_names: FootprintApiManager_get_user_defined_field_namesService;
  public async get_user_defined_field_names($inParams: { EntityTypes?: string[] }): Promise< { UserDefinedFields?: { EntityType?: string, UserDefinedFields?: { Name?: string, Type?: string }[] }[], messages?: any[] }> {
    if(!this._get_user_defined_field_names) { 
      this._get_user_defined_field_names = this.injector.get(FootprintApiManager_get_user_defined_field_namesService);
    }
    return this._get_user_defined_field_names.run($inParams);
  }
   
   

   
 
  private _get_user_defined_field_values: FootprintApiManager_get_user_defined_field_valuesService;
  public async get_user_defined_field_values($inParams: { UserDefinedFieldNames?: string[], EntityType?: string, EntityKeys?: { Name?: string, Value?: any[] }[] }): Promise< { outputs?: { EntityKeys?: { Name?: string, Value?: string }[], UserDefinedFieldValues?: { Name?: string, Value?: string }[] }[], messages?: any[] }> {
    if(!this._get_user_defined_field_values) { 
      this._get_user_defined_field_values = this.injector.get(FootprintApiManager_get_user_defined_field_valuesService);
    }
    return this._get_user_defined_field_values.run($inParams);
  }
   
   

   
 
  private _get_vendor_lots_flow: FootprintApiManager_get_vendor_lots_flowService;
  public async get_vendor_lots_flow($inParams: { paging?: { top?: number, skip?: number }, filters?: { vendor_lot_id?: number, lookup?: string, material_id?: number, material_lookup?: string, project_id?: number, project_lookup?: string, owner_id?: number, owner_lookup?: string, vat?: string, expiration_date_from?: string, expiration_date_to?: string, manufacture_date_from?: string, manufacture_date_to?: string } }): Promise< { vendor_lots?: $frontendTypes.FootprintApiManager.public_vendor_lot[], errors?: string[] }> {
    if(!this._get_vendor_lots_flow) { 
      this._get_vendor_lots_flow = this.injector.get(FootprintApiManager_get_vendor_lots_flowService);
    }
    return this._get_vendor_lots_flow.run($inParams);
  }
   
   

   
 
  private _insert_log: FootprintApiManager_insert_logService;
  public async insert_log($inParams: { level: number, process: string, notes: string }): Promise<void> {
    if(!this._insert_log) { 
      this._insert_log = this.injector.get(FootprintApiManager_insert_logService);
    }
    return this._insert_log.run($inParams);
  }
   
   

   
 
  private _integrity_check_interface_subsets: FootprintApiManager_integrity_check_interface_subsetsService;
  public async integrity_check_interface_subsets($inParams: { input_create_sales_order?: $frontendTypes.FootprintApiManager.input_create_sales_order, input_create_purchase_order?: $frontendTypes.FootprintApiManager.input_create_purchase_order, input_create_asn_order?: $frontendTypes.FootprintApiManager.input_create_asn_order, input_create_material?: $frontendTypes.FootprintApiManager.input_create_material, input_create_material_packaging?: $frontendTypes.FootprintApiManager.input_create_material_packaging, input_get_sales_order?: $frontendTypes.FootprintApiManager.input_get_sales_order, input_get_purchase_order?: $frontendTypes.FootprintApiManager.input_get_purchase_order, input_get_asn_order?: $frontendTypes.FootprintApiManager.input_get_asn_order, input_get_material?: $frontendTypes.FootprintApiManager.input_get_material, input_update_sales_order?: $frontendTypes.FootprintApiManager.input_update_sales_order, input_update_purchase_order?: $frontendTypes.FootprintApiManager.input_update_purchase_order, input_update_asn_order?: $frontendTypes.FootprintApiManager.input_update_asn_order, input_update_material?: $frontendTypes.FootprintApiManager.input_update_material, input_update_material_packaging?: $frontendTypes.FootprintApiManager.input_update_material_packaging, input_cancel_sales_order?: $frontendTypes.FootprintApiManager.input_cancel_sales_order, input_cancel_sales_order_line?: $frontendTypes.FootprintApiManager.input_cancel_sales_order_line, input_cancel_purchase_order?: $frontendTypes.FootprintApiManager.input_cancel_purchase_order, input_cancel_purchase_order_line?: $frontendTypes.FootprintApiManager.input_cancel_purchase_order_line, input_cancel_asn_order?: $frontendTypes.FootprintApiManager.input_cancel_asn_order, input_cancel_asn_order_line?: $frontendTypes.FootprintApiManager.input_cancel_asn_order_line, input_get_carrier?: $frontendTypes.FootprintApiManager.input_get_carrier, input_create_carrier?: $frontendTypes.FootprintApiManager.input_create_carrier, input_update_carrier?: $frontendTypes.FootprintApiManager.input_update_carrier, input_get_account?: $frontendTypes.FootprintApiManager.input_get_account, input_create_account?: $frontendTypes.FootprintApiManager.input_create_account, input_get_inventory?: $frontendTypes.FootprintApiManager.input_get_inventory, input_update_vendor_lot?: $frontendTypes.FootprintApiManager.input_update_vendor_lot, input_create_vendor_lot?: $frontendTypes.FootprintApiManager.input_create_vendor_lot, input_create_instruction?: $frontendTypes.FootprintApiManager.input_create_instruction, input_update_serial_number?: $frontendTypes.FootprintApiManager.input_update_serial_number, input_create_order_line?: $frontendTypes.FootprintApiManager.input_create_order_line, input_update_order?: $frontendTypes.FootprintApiManager.input_update_order, input_update_order_line?: $frontendTypes.FootprintApiManager.input_update_order_line, input_update_shipment?: $frontendTypes.FootprintApiManager.input_update_shipment, input_create_contact?: $frontendTypes.FootprintApiManager.input_create_contact, input_create_order_address?: $frontendTypes.FootprintApiManager.input_create_order_address, input_update_account?: $frontendTypes.FootprintApiManager.input_update_account, input_update_contact?: $frontendTypes.FootprintApiManager.input_update_contact, input_update_order_address?: $frontendTypes.FootprintApiManager.input_update_order_address }): Promise<void> {
    if(!this._integrity_check_interface_subsets) { 
      this._integrity_check_interface_subsets = this.injector.get(FootprintApiManager_integrity_check_interface_subsetsService);
    }
    return this._integrity_check_interface_subsets.run($inParams);
  }
   
   

   
 
  private _inventory_adjustment_query: FootprintApiManager_inventory_adjustment_queryService;
  public async inventory_adjustment_query($inParams: { owner?: string, project: string, warehouse?: string, modifiedFrom?: string, modifiedTo?: string, hasTransmissions?: boolean, summary?: boolean }): Promise< { payload?: any[], messages?: any[] }> {
    if(!this._inventory_adjustment_query) { 
      this._inventory_adjustment_query = this.injector.get(FootprintApiManager_inventory_adjustment_queryService);
    }
    return this._inventory_adjustment_query.run($inParams);
  }
   
   

   
 
  private _inventory_snapshot_query: FootprintApiManager_inventory_snapshot_queryService;
  public async inventory_snapshot_query($inParams: { owner?: string, project: string, warehouse?: string, material?: string, date?: string }): Promise< { payload?: any[], messages?: any[] }> {
    if(!this._inventory_snapshot_query) { 
      this._inventory_snapshot_query = this.injector.get(FootprintApiManager_inventory_snapshot_queryService);
    }
    return this._inventory_snapshot_query.run($inParams);
  }
   
   

   
 
  private _is_asn_order_cancelable_flow: FootprintApiManager_is_asn_order_cancelable_flowService;
  public async is_asn_order_cancelable_flow($inParams: { order_id: number, status_id: number }): Promise< { reasons?: string[] }> {
    if(!this._is_asn_order_cancelable_flow) { 
      this._is_asn_order_cancelable_flow = this.injector.get(FootprintApiManager_is_asn_order_cancelable_flowService);
    }
    return this._is_asn_order_cancelable_flow.run($inParams);
  }
   
   

   
 
  private _lifecycle_clean: FootprintApiManager_lifecycle_cleanService;
  public async lifecycle_clean($inParams: { integration_names: string[], days_to_retain: number, additional_criteria?: any }): Promise< { success?: boolean, messages?: any[] }> {
    if(!this._lifecycle_clean) { 
      this._lifecycle_clean = this.injector.get(FootprintApiManager_lifecycle_cleanService);
    }
    return this._lifecycle_clean.run($inParams);
  }
   
   

   
 
  private _list_integrations: FootprintApiManager_list_integrationsService;
  public async list_integrations($inParams: { integration_name?: string, action?: string }): Promise< { list?: { id?: string, integration_name?: string }[] }> {
    if(!this._list_integrations) { 
      this._list_integrations = this.injector.get(FootprintApiManager_list_integrationsService);
    }
    return this._list_integrations.run($inParams);
  }
   
   

   
 
  private _list_processes: FootprintApiManager_list_processesService;
  public async list_processes($inParams: { process?: string, action?: string }): Promise< { list?: { id?: string, process?: string }[] }> {
    if(!this._list_processes) { 
      this._list_processes = this.injector.get(FootprintApiManager_list_processesService);
    }
    return this._list_processes.run($inParams);
  }
   
   

   
 
  private _list_statuses: FootprintApiManager_list_statusesService;
  public async list_statuses($inParams: { status?: string, action?: string }): Promise< { list?: { id?: string, status?: string }[] }> {
    if(!this._list_statuses) { 
      this._list_statuses = this.injector.get(FootprintApiManager_list_statusesService);
    }
    return this._list_statuses.run($inParams);
  }
   
   

   
 
  private _list_transaction_types: FootprintApiManager_list_transaction_typesService;
  public async list_transaction_types($inParams: { transaction_type?: string, action?: string }): Promise< { list?: { id?: string, transaction_type?: string }[] }> {
    if(!this._list_transaction_types) { 
      this._list_transaction_types = this.injector.get(FootprintApiManager_list_transaction_typesService);
    }
    return this._list_transaction_types.run($inParams);
  }
   
   

   
 
  private _logs_clean: FootprintApiManager_logs_cleanService;
  public async logs_clean($inParams: { integration_names: string[], levels_to_purge: number[], days_to_retain: number, additional_criteria?: any }): Promise< { success?: boolean, messages?: any[] }> {
    if(!this._logs_clean) { 
      this._logs_clean = this.injector.get(FootprintApiManager_logs_cleanService);
    }
    return this._logs_clean.run($inParams);
  }
   
   

   
 
  private _lot_create: FootprintApiManager_lot_createService;
  public async lot_create($inParams: { vendorLotId: number, materialId: number, lookupCode?: string, description?: string, notes?: string }): Promise< { id?: number, success?: boolean, messages?: any[] }> {
    if(!this._lot_create) { 
      this._lot_create = this.injector.get(FootprintApiManager_lot_createService);
    }
    return this._lot_create.run($inParams);
  }
   
   

   
 
  private _main_auto_email_execute_rules_flow: FootprintApiManager_main_auto_email_execute_rules_flowService;
  public async main_auto_email_execute_rules_flow($inParams: {  }): Promise< { results?: any[] }> {
    if(!this._main_auto_email_execute_rules_flow) { 
      this._main_auto_email_execute_rules_flow = this.injector.get(FootprintApiManager_main_auto_email_execute_rules_flowService);
    }
    return this._main_auto_email_execute_rules_flow.run($inParams);
  }
   
   

   
 
  private _messages_clean: FootprintApiManager_messages_cleanService;
  public async messages_clean($inParams: { integration_names: string[], days_to_retain: number, additional_criteria?: any }): Promise< { success?: boolean, messages?: any[] }> {
    if(!this._messages_clean) { 
      this._messages_clean = this.injector.get(FootprintApiManager_messages_cleanService);
    }
    return this._messages_clean.run($inParams);
  }
   
   

   
 
  private _migrate_storage_to_utilities: FootprintApiManager_migrate_storage_to_utilitiesService;
  public async migrate_storage_to_utilities($inParams: {  }): Promise< { error?: any[] }> {
    if(!this._migrate_storage_to_utilities) { 
      this._migrate_storage_to_utilities = this.injector.get(FootprintApiManager_migrate_storage_to_utilitiesService);
    }
    return this._migrate_storage_to_utilities.run($inParams);
  }
   
   

   
 
  private _move_serial_numbers_flow: FootprintApiManager_move_serial_numbers_flowService;
  public async move_serial_numbers_flow($inParams: { serial_numbers: $frontendTypes.FootprintApiManager.input_move_serial_number[], target_license_plate: { lookup: string, warehouse?: string } }): Promise< { errors?: string[] }> {
    if(!this._move_serial_numbers_flow) { 
      this._move_serial_numbers_flow = this.injector.get(FootprintApiManager_move_serial_numbers_flowService);
    }
    return this._move_serial_numbers_flow.run($inParams);
  }
   
   

   
 
  private _order_revisions: FootprintApiManager_order_revisionsService;
  public async order_revisions($inParams: { owner_lookups?: string[], project_lookups?: string[], type_id?: number, options?: { lookup_code?: boolean, owner_reference?: boolean, vendor_reference?: boolean, only_created?: boolean, output_data?: boolean }, days?: number, minutes?: number }): Promise< { output?: any[] }> {
    if(!this._order_revisions) { 
      this._order_revisions = this.injector.get(FootprintApiManager_order_revisionsService);
    }
    return this._order_revisions.run($inParams);
  }
   
   

   
 
  private _owner_create: FootprintApiManager_owner_createService;
  public async owner_create($inParams: { lookupCode: string, name?: string, notes?: string }): Promise< { id?: number, success?: boolean, messages?: any[] }> {
    if(!this._owner_create) { 
      this._owner_create = this.injector.get(FootprintApiManager_owner_createService);
    }
    return this._owner_create.run($inParams);
  }
   
   

   
 
  private _print_cloud_report: FootprintApiManager_print_cloud_reportService;
  public async print_cloud_report($inParams: { packageName: string, reportName: string, reportInputs: any, printerName: string }): Promise< { reasons?: string[] }> {
    if(!this._print_cloud_report) { 
      this._print_cloud_report = this.injector.get(FootprintApiManager_print_cloud_reportService);
    }
    return this._print_cloud_report.run($inParams);
  }
   
   

   
 
  private _purchase_order_create: FootprintApiManager_purchase_order_createService;
  public async purchase_order_create($inParams: { owner?: string, project?: string, ownerReference?: string, vendorReference?: string, requestedDeliveryDate?: string, notes?: string, orderLines?: $frontendTypes.FootprintApiManager.Cloud_OrderLine[], warehouse?: string, addresses?: $frontendTypes.FootprintApiManager.Cloud_OrderAddress[], customFields?: any, carrier?: string, carrierServiceType?: string }): Promise< { orderId?: number }> {
    if(!this._purchase_order_create) { 
      this._purchase_order_create = this.injector.get(FootprintApiManager_purchase_order_createService);
    }
    return this._purchase_order_create.run($inParams);
  }
   
   

   
 
  private _purchase_order_query: FootprintApiManager_purchase_order_queryService;
  public async purchase_order_query($inParams: { lookupCode?: string, owner?: string, project: string, ownerReference?: string, vendorReference?: string, warehouse?: string, status?: string, modifiedFrom?: string, modifiedTo?: string }): Promise< { payload?: any[] }> {
    if(!this._purchase_order_query) { 
      this._purchase_order_query = this.injector.get(FootprintApiManager_purchase_order_queryService);
    }
    return this._purchase_order_query.run($inParams);
  }
   
   

   
 
  private _purge_old_records: FootprintApiManager_purge_old_recordsService;
  public async purge_old_records($inParams: { days_to_retain?: number }): Promise< { messages?: any[] }> {
    if(!this._purge_old_records) { 
      this._purge_old_records = this.injector.get(FootprintApiManager_purge_old_recordsService);
    }
    return this._purge_old_records.run($inParams);
  }
   
   

   
 
  private _reset_locked_messages: FootprintApiManager_reset_locked_messagesService;
  public async reset_locked_messages($inParams: { min_hours?: number, max_hours?: number, integration_names?: string[] }): Promise< { messages?: any[] }> {
    if(!this._reset_locked_messages) { 
      this._reset_locked_messages = this.injector.get(FootprintApiManager_reset_locked_messagesService);
    }
    return this._reset_locked_messages.run($inParams);
  }
   
   

   
 
  private _sales_order_create: FootprintApiManager_sales_order_createService;
  public async sales_order_create($inParams: { owner?: string, project?: string, ownerReference?: string, vendorReference?: string, requestedDeliveryDate?: string, notes?: string, orderLines?: $frontendTypes.FootprintApiManager.Cloud_OrderLine[], warehouse?: string, addresses?: $frontendTypes.FootprintApiManager.Cloud_OrderAddress[], customFields?: any, carrier?: string, carrierServiceType?: string }): Promise< { orderId?: number }> {
    if(!this._sales_order_create) { 
      this._sales_order_create = this.injector.get(FootprintApiManager_sales_order_createService);
    }
    return this._sales_order_create.run($inParams);
  }
   
   

   
 
  private _sales_order_query: FootprintApiManager_sales_order_queryService;
  public async sales_order_query($inParams: { lookupCode?: string, owner?: string, project: string, ownerReference?: string, vendorReference?: string, warehouse?: string, status?: string, modifiedFrom?: string, modifiedTo?: string, trackQueriedOrders?: boolean, paging?: { top?: number, skip?: number }, shippedFrom?: string, shippedTo?: string }): Promise< { payload?: any[] }> {
    if(!this._sales_order_query) { 
      this._sales_order_query = this.injector.get(FootprintApiManager_sales_order_queryService);
    }
    return this._sales_order_query.run($inParams);
  }
   
   

   
 
  private _sales_order_shipping_summary_query: FootprintApiManager_sales_order_shipping_summary_queryService;
  public async sales_order_shipping_summary_query($inParams: { lookupCode?: string, owner?: string, project: string, ownerReference?: string, vendorReference?: string, warehouse?: string, shippedFrom?: string, shippedTo?: string }): Promise< { payload?: any[] }> {
    if(!this._sales_order_shipping_summary_query) { 
      this._sales_order_shipping_summary_query = this.injector.get(FootprintApiManager_sales_order_shipping_summary_queryService);
    }
    return this._sales_order_shipping_summary_query.run($inParams);
  }
   
   

   
 
  private _sftp_pull: FootprintApiManager_sftp_pullService;
  public async sftp_pull($inParams: { connection: string, source_path: string, archive_path?: string, error_path?: string, file_extension?: string, file_name?: string, sort_asc?: boolean, transaction_id?: string }): Promise< { messages?: any[], success?: boolean, files?: { file_name?: string, file_blob?: any }[] }> {
    if(!this._sftp_pull) { 
      this._sftp_pull = this.injector.get(FootprintApiManager_sftp_pullService);
    }
    return this._sftp_pull.run($inParams);
  }
   
   

   
 
  private _sftp_push: FootprintApiManager_sftp_pushService;
  public async sftp_push($inParams: { connection: string, target_path: string, transit_path?: string, transaction_id?: string, files: { file_name?: string, file_blob?: any }[] }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._sftp_push) { 
      this._sftp_push = this.injector.get(FootprintApiManager_sftp_pushService);
    }
    return this._sftp_push.run($inParams);
  }
   
   

   
 
  private _storage_adjustments: FootprintApiManager_storage_adjustmentsService;
  public async storage_adjustments($inParams: { payload?: { id?: string, task_id?: number, project_id?: number, task_data?: string, license_plate_data?: string }, action: string, skip?: number, take?: number, date_from?: string, date_to?: string, integration_name: string, task_ids?: number[] }): Promise< { payload?: { id?: string, task_id?: number, project_id?: number, task_data?: string, license_plate_data?: string, integration_name?: string, created_on?: string }[], success?: boolean, error?: any[] }> {
    if(!this._storage_adjustments) { 
      this._storage_adjustments = this.injector.get(FootprintApiManager_storage_adjustmentsService);
    }
    return this._storage_adjustments.run($inParams);
  }
   
   

   
 
  private _storage_configurations: FootprintApiManager_storage_configurationsService;
  public async storage_configurations($inParams: { payload?: { id?: string, name?: string, value?: string, notes?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, user_name?: string }, action: string, skip?: number, take?: number, integration_name: string }): Promise< { payload?: { id?: string, name?: string, value?: string, notes?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, integration_name?: string, user_name?: string }[], success?: boolean, error?: any[], count?: number }> {
    if(!this._storage_configurations) { 
      this._storage_configurations = this.injector.get(FootprintApiManager_storage_configurationsService);
    }
    return this._storage_configurations.run($inParams);
  }
   
   

   
 
  private _storage_control: FootprintApiManager_storage_controlService;
  public async storage_control($inParams: { action: string, payload?: { id?: string, type?: string, identifier?: string, direction?: string, count?: number, created_date?: string, modified_date?: string, search?: string, user_name?: string }, skip?: number, take?: number, option?: string, integration_name: string }): Promise< { payload?: { id?: string, type?: string, identifier?: string, direction?: string, count?: number, created_date?: string, modified_date?: string, integration_name?: string, user_name?: string }[], control_number?: number, success?: boolean, error?: any[] }> {
    if(!this._storage_control) { 
      this._storage_control = this.injector.get(FootprintApiManager_storage_controlService);
    }
    return this._storage_control.run($inParams);
  }
   
   

   
 
  private _storage_lifecycle: FootprintApiManager_storage_lifecycleService;
  public async storage_lifecycle($inParams: { action: string, payload?: { id?: string, sender?: string, receiver?: string, ingress_type?: string, ingress_id?: string, transaction_id?: string, translation_status?: string, import_status?: string, order_status?: string, reference?: string, export_status?: string, send_status?: string, egress_type?: string, egress_id?: string, date_time?: string, environment?: string }, skip?: number, take?: number, integration_name: string, statuses?: string[] }): Promise< { payload?: { id?: string, sender?: string, receiver?: string, ingress_type?: string, ingress_id?: string, transaction_id?: string, translation_status?: string, import_status?: string, order_status?: string, reference?: string, export_status?: string, send_status?: string, egress_type?: string, egress_id?: string, date_time?: string, environment?: string, integration_name?: string }[], success?: boolean, count?: number }> {
    if(!this._storage_lifecycle) { 
      this._storage_lifecycle = this.injector.get(FootprintApiManager_storage_lifecycleService);
    }
    return this._storage_lifecycle.run($inParams);
  }
   
   

   
 
  private _storage_logs: FootprintApiManager_storage_logsService;
  public async storage_logs($inParams: { payload?: { id?: string, level?: number, process?: string, notes?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, created_by?: string, created_on?: string, alerted_on?: string }, action: string, skip?: number, take?: number, date_from?: string, date_to?: string, integration_name: string }): Promise< { payload?: { id?: string, level?: number, process?: string, notes?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, created_by?: string, created_on?: string, alerted_on?: string, integration_name?: string, message?: string }[], success?: boolean, error?: any[], count?: number }> {
    if(!this._storage_logs) { 
      this._storage_logs = this.injector.get(FootprintApiManager_storage_logsService);
    }
    return this._storage_logs.run($inParams);
  }
   
   

   
 
  private _storage_messages: FootprintApiManager_storage_messagesService;
  public async storage_messages($inParams: { payload?: { id?: string, status?: string, direction?: string, process?: string, reference?: string, sender?: string, receiver?: string, payload?: string, notes?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, transaction_type?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, request_id?: string, environment?: string }, action: string, skip?: number, take?: number, date_from?: string, date_to?: string, integration_name: string }): Promise< { payload?: { id?: string, status?: string, direction?: string, process?: string, reference?: string, sender?: string, receiver?: string, payload?: string, notes?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, transaction_type?: string, transaction_id?: string, integration_name?: string, ingress_id?: string, egress_id?: string, request_id?: string, environment?: string }[], success?: boolean, error?: any[], count?: number }> {
    if(!this._storage_messages) { 
      this._storage_messages = this.injector.get(FootprintApiManager_storage_messagesService);
    }
    return this._storage_messages.run($inParams);
  }
   
   

   
 
  private _storage_string_encrypt: FootprintApiManager_storage_string_encryptService;
  public async storage_string_encrypt($inParams: { text?: string, encrypted?: string }): Promise< { text?: string, encrypted?: string }> {
    if(!this._storage_string_encrypt) { 
      this._storage_string_encrypt = this.injector.get(FootprintApiManager_storage_string_encryptService);
    }
    return this._storage_string_encrypt.run($inParams);
  }
   
   

   
 
  private _storage_test: FootprintApiManager_storage_testService;
  public async storage_test($inParams: { rounds?: number, messages?: number, purge?: boolean }): Promise< { messages?: any[] }> {
    if(!this._storage_test) { 
      this._storage_test = this.injector.get(FootprintApiManager_storage_testService);
    }
    return this._storage_test.run($inParams);
  }
   
   

   
 
  private _submit_entity_import_json_request: FootprintApiManager_submit_entity_import_json_requestService;
  public async submit_entity_import_json_request($inParams: { entityImport?: any, referenceCode?: string, project?: string, warehouse?: string, groupId?: string, transactionGroupId?: string, transactionId?: string }): Promise< { requestId?: string }> {
    if(!this._submit_entity_import_json_request) { 
      this._submit_entity_import_json_request = this.injector.get(FootprintApiManager_submit_entity_import_json_requestService);
    }
    return this._submit_entity_import_json_request.run($inParams);
  }
   
   

   
 
  private _submit_entity_import_xml_request: FootprintApiManager_submit_entity_import_xml_requestService;
  public async submit_entity_import_xml_request($inParams: { referenceCode?: string, entityImportXml?: string, project?: string, warehouse?: string, groupId?: string, transactionGroupId?: string, transactionId?: string }): Promise< { requestId?: string }> {
    if(!this._submit_entity_import_xml_request) { 
      this._submit_entity_import_xml_request = this.injector.get(FootprintApiManager_submit_entity_import_xml_requestService);
    }
    return this._submit_entity_import_xml_request.run($inParams);
  }
   
   

   
 
  private _translate_material_from_footprint_to_public_flow: FootprintApiManager_translate_material_from_footprint_to_public_flowService;
  public async translate_material_from_footprint_to_public_flow($inParams: { footprint_materials: $frontendTypes.Materials.Material[] }): Promise< { public_materials: $frontendTypes.FootprintApiManager.public_material[] }> {
    if(!this._translate_material_from_footprint_to_public_flow) { 
      this._translate_material_from_footprint_to_public_flow = this.injector.get(FootprintApiManager_translate_material_from_footprint_to_public_flowService);
    }
    return this._translate_material_from_footprint_to_public_flow.run($inParams);
  }
   
   

   
 
  private _translate_material_from_public_to_footprint_flow: FootprintApiManager_translate_material_from_public_to_footprint_flowService;
  public async translate_material_from_public_to_footprint_flow($inParams: { public_materials: $frontendTypes.FootprintApiManager.public_material[], default_missing_values_to_null?: boolean }): Promise< { footprint_materials: $frontendTypes.Materials.Material[] }> {
    if(!this._translate_material_from_public_to_footprint_flow) { 
      this._translate_material_from_public_to_footprint_flow = this.injector.get(FootprintApiManager_translate_material_from_public_to_footprint_flowService);
    }
    return this._translate_material_from_public_to_footprint_flow.run($inParams);
  }
   
   

   
 
  private _translate_sales_order_from_public_to_footprint_flow: FootprintApiManager_translate_sales_order_from_public_to_footprint_flowService;
  public async translate_sales_order_from_public_to_footprint_flow($inParams: { public_materials: $frontendTypes.FootprintApiManager.public_material[] }): Promise< { footprint_materials: $frontendTypes.Materials.Material[] }> {
    if(!this._translate_sales_order_from_public_to_footprint_flow) { 
      this._translate_sales_order_from_public_to_footprint_flow = this.injector.get(FootprintApiManager_translate_sales_order_from_public_to_footprint_flowService);
    }
    return this._translate_sales_order_from_public_to_footprint_flow.run($inParams);
  }
   
   

   
 
  private _translate_serial_number_from_footprint_to_public_flow: FootprintApiManager_translate_serial_number_from_footprint_to_public_flowService;
  public async translate_serial_number_from_footprint_to_public_flow($inParams: { footprint_serial_numbers: any[] }): Promise< { public_serial_numbers: $frontendTypes.FootprintApiManager.public_serial_number[], errors?: string[] }> {
    if(!this._translate_serial_number_from_footprint_to_public_flow) { 
      this._translate_serial_number_from_footprint_to_public_flow = this.injector.get(FootprintApiManager_translate_serial_number_from_footprint_to_public_flowService);
    }
    return this._translate_serial_number_from_footprint_to_public_flow.run($inParams);
  }
   
   

   
 
  private _translate_serial_number_from_public_to_footprint_flow: FootprintApiManager_translate_serial_number_from_public_to_footprint_flowService;
  public async translate_serial_number_from_public_to_footprint_flow($inParams: { public_serial_numbers: $frontendTypes.FootprintApiManager.public_serial_number[] }): Promise< { footprint_serial_numbers: { Archived?: boolean, ChainHead?: number, DimensionsUom?: { Short_name?: string, Id?: number }, GrossVolume?: number, GrossWeight?: number, Height?: number, Id?: number, Length?: number, LicensePlate?: { LookupCode?: string, Id?: number }, LookupCode?: string, NetWeight?: number, NetVolume?: number, Notes?: string, OriginalChainHead?: number, OutboundShipment?: { LookupCode?: string, Id?: number }, Packaging?: { ShortName?: string, Id?: number }, Status?: { Name?: string, Id?: number }, VolumeUom?: { Short_name?: string, Id?: number }, WeightUom?: { Short_name?: string, Id?: number }, Width?: number, ContainsPortalVisibleAttachments?: boolean, Lot?: { Id?: number, LookupCode?: string }, custom_fields?: $frontendTypes.FootprintApiManager.public_custom_field[] }[], errors?: string[] }> {
    if(!this._translate_serial_number_from_public_to_footprint_flow) { 
      this._translate_serial_number_from_public_to_footprint_flow = this.injector.get(FootprintApiManager_translate_serial_number_from_public_to_footprint_flowService);
    }
    return this._translate_serial_number_from_public_to_footprint_flow.run($inParams);
  }
   
   

   
 
  private _unpick_licenseplate_flow: FootprintApiManager_unpick_licenseplate_flowService;
  public async unpick_licenseplate_flow($inParams: { licenseplateId: number }): Promise< { reason?: string }> {
    if(!this._unpick_licenseplate_flow) { 
      this._unpick_licenseplate_flow = this.injector.get(FootprintApiManager_unpick_licenseplate_flowService);
    }
    return this._unpick_licenseplate_flow.run($inParams);
  }
   
   

   
 
  private _update_accounts_flow: FootprintApiManager_update_accounts_flowService;
  public async update_accounts_flow($inParams: { accounts: $frontendTypes.FootprintApiManager.input_update_account[] }): Promise< { errors?: string[] }> {
    if(!this._update_accounts_flow) { 
      this._update_accounts_flow = this.injector.get(FootprintApiManager_update_accounts_flowService);
    }
    return this._update_accounts_flow.run($inParams);
  }
   
   

   
 
  private _update_asn_order: FootprintApiManager_update_asn_orderService;
  public async update_asn_order($inParams: { order_id: number, update: $frontendTypes.FootprintApiManager.input_update_asn_order }): Promise< { order?: $frontendTypes.FootprintApiManager.public_order, log?: any }> {
    if(!this._update_asn_order) { 
      this._update_asn_order = this.injector.get(FootprintApiManager_update_asn_orderService);
    }
    return this._update_asn_order.run($inParams);
  }
   
   

   
 
  private _update_asn_orders_flow: FootprintApiManager_update_asn_orders_flowService;
  public async update_asn_orders_flow($inParams: { asn_orders: $frontendTypes.FootprintApiManager.input_update_asn_order[] }): Promise< { errors?: string[] }> {
    if(!this._update_asn_orders_flow) { 
      this._update_asn_orders_flow = this.injector.get(FootprintApiManager_update_asn_orders_flowService);
    }
    return this._update_asn_orders_flow.run($inParams);
  }
   
   

   
 
  private _update_carriers_flow: FootprintApiManager_update_carriers_flowService;
  public async update_carriers_flow($inParams: { carriers: $frontendTypes.FootprintApiManager.input_update_carrier[] }): Promise< { errors?: string[] }> {
    if(!this._update_carriers_flow) { 
      this._update_carriers_flow = this.injector.get(FootprintApiManager_update_carriers_flowService);
    }
    return this._update_carriers_flow.run($inParams);
  }
   
   

   
 
  private _update_contacts_flow: FootprintApiManager_update_contacts_flowService;
  public async update_contacts_flow($inParams: { contacts: $frontendTypes.FootprintApiManager.input_update_contact[] }): Promise< { errors?: string[] }> {
    if(!this._update_contacts_flow) { 
      this._update_contacts_flow = this.injector.get(FootprintApiManager_update_contacts_flowService);
    }
    return this._update_contacts_flow.run($inParams);
  }
   
   

   
 
  private _update_dock_appointments_flow: FootprintApiManager_update_dock_appointments_flowService;
  public async update_dock_appointments_flow($inParams: { dock_appointments: $frontendTypes.FootprintApiManager.input_update_dock_appointment[] }): Promise< { errors?: string[] }> {
    if(!this._update_dock_appointments_flow) { 
      this._update_dock_appointments_flow = this.injector.get(FootprintApiManager_update_dock_appointments_flowService);
    }
    return this._update_dock_appointments_flow.run($inParams);
  }
   
   

   
 
  private _update_last_wavelength_transmission: FootprintApiManager_update_last_wavelength_transmissionService;
  public async update_last_wavelength_transmission($inParams: { transaction_id?: string, transmission_direction?: string, transmission_type?: string, notes?: string }): Promise<void> {
    if(!this._update_last_wavelength_transmission) { 
      this._update_last_wavelength_transmission = this.injector.get(FootprintApiManager_update_last_wavelength_transmissionService);
    }
    return this._update_last_wavelength_transmission.run($inParams);
  }
   
   

   
 
  private _update_lots_flow: FootprintApiManager_update_lots_flowService;
  public async update_lots_flow($inParams: { lots: $frontendTypes.FootprintApiManager.input_update_lot[] }): Promise< { errors?: string[] }> {
    if(!this._update_lots_flow) { 
      this._update_lots_flow = this.injector.get(FootprintApiManager_update_lots_flowService);
    }
    return this._update_lots_flow.run($inParams);
  }
   
   

   
 
  private _update_material_packaging: FootprintApiManager_update_material_packagingService;
  public async update_material_packaging($inParams: { material_id: number, packaging: number, update: $frontendTypes.FootprintApiManager.input_update_material_packaging }): Promise< { material_packaging?: $frontendTypes.FootprintApiManager.public_material_packaging }> {
    if(!this._update_material_packaging) { 
      this._update_material_packaging = this.injector.get(FootprintApiManager_update_material_packagingService);
    }
    return this._update_material_packaging.run($inParams);
  }
   
   

   
 
  private _update_materials_flow: FootprintApiManager_update_materials_flowService;
  public async update_materials_flow($inParams: { materials: $frontendTypes.FootprintApiManager.input_update_material[] }): Promise< { errors?: string[], materials?: $frontendTypes.FootprintApiManager.public_material[] }> {
    if(!this._update_materials_flow) { 
      this._update_materials_flow = this.injector.get(FootprintApiManager_update_materials_flowService);
    }
    return this._update_materials_flow.run($inParams);
  }
   
   

   
 
  private _update_order_addresses_flow: FootprintApiManager_update_order_addresses_flowService;
  public async update_order_addresses_flow($inParams: { order_addresses: $frontendTypes.FootprintApiManager.input_update_order_address[] }): Promise< { errors?: string[] }> {
    if(!this._update_order_addresses_flow) { 
      this._update_order_addresses_flow = this.injector.get(FootprintApiManager_update_order_addresses_flowService);
    }
    return this._update_order_addresses_flow.run($inParams);
  }
   
   

   
 
  private _update_pallet_transactions_flow: FootprintApiManager_update_pallet_transactions_flowService;
  public async update_pallet_transactions_flow($inParams: { pallet_transactions: $frontendTypes.FootprintApiManager.input_update_pallet_transaction[] }): Promise< { errors?: string[] }> {
    if(!this._update_pallet_transactions_flow) { 
      this._update_pallet_transactions_flow = this.injector.get(FootprintApiManager_update_pallet_transactions_flowService);
    }
    return this._update_pallet_transactions_flow.run($inParams);
  }
   
   

   
 
  private _update_purchase_order_lines_flow: FootprintApiManager_update_purchase_order_lines_flowService;
  public async update_purchase_order_lines_flow($inParams: { order_lines: $frontendTypes.FootprintApiManager.input_update_purchase_order_line[] }): Promise< { errors?: string[] }> {
    if(!this._update_purchase_order_lines_flow) { 
      this._update_purchase_order_lines_flow = this.injector.get(FootprintApiManager_update_purchase_order_lines_flowService);
    }
    return this._update_purchase_order_lines_flow.run($inParams);
  }
   
   

   
 
  private _update_purchase_orders_flow: FootprintApiManager_update_purchase_orders_flowService;
  public async update_purchase_orders_flow($inParams: { purchase_orders: $frontendTypes.FootprintApiManager.input_update_purchase_order[] }): Promise< { errors?: string[] }> {
    if(!this._update_purchase_orders_flow) { 
      this._update_purchase_orders_flow = this.injector.get(FootprintApiManager_update_purchase_orders_flowService);
    }
    return this._update_purchase_orders_flow.run($inParams);
  }
   
   

   
 
  private _update_sales_order_lines_flow: FootprintApiManager_update_sales_order_lines_flowService;
  public async update_sales_order_lines_flow($inParams: { order_lines: $frontendTypes.FootprintApiManager.input_update_sales_order_line[] }): Promise< { errors?: string[] }> {
    if(!this._update_sales_order_lines_flow) { 
      this._update_sales_order_lines_flow = this.injector.get(FootprintApiManager_update_sales_order_lines_flowService);
    }
    return this._update_sales_order_lines_flow.run($inParams);
  }
   
   

   
 
  private _update_sales_orders_flow: FootprintApiManager_update_sales_orders_flowService;
  public async update_sales_orders_flow($inParams: { sales_orders: $frontendTypes.FootprintApiManager.input_update_sales_order[] }): Promise< { errors: string[] }> {
    if(!this._update_sales_orders_flow) { 
      this._update_sales_orders_flow = this.injector.get(FootprintApiManager_update_sales_orders_flowService);
    }
    return this._update_sales_orders_flow.run($inParams);
  }
   
   

   
 
  private _update_serial_number_statuses_flow: FootprintApiManager_update_serial_number_statuses_flowService;
  public async update_serial_number_statuses_flow($inParams: { serial_numbers: $frontendTypes.FootprintApiManager.input_update_serial_numbers_status[] }): Promise< { errors?: string[] }> {
    if(!this._update_serial_number_statuses_flow) { 
      this._update_serial_number_statuses_flow = this.injector.get(FootprintApiManager_update_serial_number_statuses_flowService);
    }
    return this._update_serial_number_statuses_flow.run($inParams);
  }
   
   

   
 
  private _update_serial_numbers: FootprintApiManager_update_serial_numbersService;
  public async update_serial_numbers($inParams: { serial_numbers: $frontendTypes.FootprintApiManager.input_update_serial_number[] }): Promise< { serial_numbers: $frontendTypes.FootprintApiManager.public_serial_number[], errors: string[] }> {
    if(!this._update_serial_numbers) { 
      this._update_serial_numbers = this.injector.get(FootprintApiManager_update_serial_numbersService);
    }
    return this._update_serial_numbers.run($inParams);
  }
   
   

   
 
  private _update_shipments: FootprintApiManager_update_shipmentsService;
  public async update_shipments($inParams: { shipments: $frontendTypes.FootprintApiManager.input_update_shipment[] }): Promise< { errors?: string[] }> {
    if(!this._update_shipments) { 
      this._update_shipments = this.injector.get(FootprintApiManager_update_shipmentsService);
    }
    return this._update_shipments.run($inParams);
  }
   
   

   
 
  private _update_vendor_lot: FootprintApiManager_update_vendor_lotService;
  public async update_vendor_lot($inParams: { vendor_lot_id: number, update: $frontendTypes.FootprintApiManager.input_update_vendor_lot }): Promise< { vendor_lot?: $frontendTypes.FootprintApiManager.public_vendor_lot }> {
    if(!this._update_vendor_lot) { 
      this._update_vendor_lot = this.injector.get(FootprintApiManager_update_vendor_lotService);
    }
    return this._update_vendor_lot.run($inParams);
  }
   
   

   
 
  private _update_vendor_lots_flow: FootprintApiManager_update_vendor_lots_flowService;
  public async update_vendor_lots_flow($inParams: { vendor_lots: $frontendTypes.FootprintApiManager.input_update_vendor_lot[] }): Promise< { errors?: string[] }> {
    if(!this._update_vendor_lots_flow) { 
      this._update_vendor_lots_flow = this.injector.get(FootprintApiManager_update_vendor_lots_flowService);
    }
    return this._update_vendor_lots_flow.run($inParams);
  }
   
   

   
 
  private _validate_create_sales_order_request_flow: FootprintApiManager_validate_create_sales_order_request_flowService;
  public async validate_create_sales_order_request_flow($inParams: { order: { owner?: string, project?: string, owner_reference?: string, vendor_reference?: string, requested_delivery_date?: string, notes?: string, warehouse?: string, carrier?: string, carrier_service_type?: string, order_lines?: any, addresses?: any, custom_fields?: any } }): Promise<void> {
    if(!this._validate_create_sales_order_request_flow) { 
      this._validate_create_sales_order_request_flow = this.injector.get(FootprintApiManager_validate_create_sales_order_request_flowService);
    }
    return this._validate_create_sales_order_request_flow.run($inParams);
  }
   
   

   
 
  private _vendor_lot_create: FootprintApiManager_vendor_lot_createService;
  public async vendor_lot_create($inParams: { materialId: number, lookupCode?: string, description?: string, notes?: string, expirationDate?: string, manufactureDate?: string, vat?: string }): Promise< { id?: number, success?: boolean, messages?: any[] }> {
    if(!this._vendor_lot_create) { 
      this._vendor_lot_create = this.injector.get(FootprintApiManager_vendor_lot_createService);
    }
    return this._vendor_lot_create.run($inParams);
  }
   
   

   
}
